{
  "shippingFees": {
    "sectionTitle": "Shipping fees",
    "sectionDescription": "Per-variant shipping fee by service and destination zone. Service and zone labels are localized; wire codes stay English.",
    "columns": {
      "service": "Service",
      "zone": "Zone",
      "shippingFee": "Shipping fee",
      "additionalFee": "Additional fee"
    },
    "columnHints": {
      "shippingFee": "Fee for the first item",
      "additionalFee": "Fee for each additional item"
    },
    "addService": "Add service",
    "removeService": "Remove service",
    "zoneOverride": {
      "title": "Zone overrides",
      "description": "Override the default fee for specific destination zones.",
      "addZone": "Add zone override",
      "removeZone": "Remove zone override",
      "defaultZone": "Default (all zones)"
    },
    "toasts": {
      "saved": "Shipping fees saved.",
      "error": "Failed to save shipping fees."
    },
    "errors": {
      "SHIPPING_SERVICE_FEE_REQUIRED": "A shipping fee is required for the selected service.",
      "BLUEPRINT_STANDARD_SERVICE_REQUIRED": "A Standard domestic service fee is required.",
      "SERVICE_CODE_INVALID": "This service code is not available in the catalog.",
      "SHIPPING_METHOD_IN_USE": "This service is still in use and cannot be removed.",
      "feeRequired": "Enter a shipping fee.",
      "feeInvalid": "Enter a valid fee amount.",
      "duplicateService": "This service has already been added.",
      "duplicateZone": "This zone already has an override."
    }
  },
  "shippingAggregation": {
    "_vgBinding": "vg-binding: P14.D-05 — Merchant Detail shippingAggregationMode toggle labels/helper/toasts (per_line|highest_base) across en/vi/fr [task-16]",
    "title": "Shipping fee aggregation",
    "ariaLabel": "Toggle shipping fee aggregation mode",
    "readOnly": "You do not have permission to change this setting.",
    "modes": {
      "per_line": "Per line",
      "highest_base": "Highest base"
    },
    "helper": {
      "per_line": "Per line: each variant's shipping fee is summed independently across the order.",
      "highest_base": "Highest base: the highest base fee in the order plus the additional fee for the remaining items."
    },
    "toasts": {
      "saved": "Shipping aggregation mode updated.",
      "error": "Failed to update shipping aggregation mode."
    }
  },
  "common": {
    "updatedDate": "Updated"
  },
  "logisticsTable": {
    "selectAllRowsAria": "Select all rows",
    "columnStatus": "Status",
    "statusToggleAria": "Toggle status for {{sku}}",
    "emptyGenerateOptionsFirst": "No SKUs yet — pick options in the Options block first."
  },
  "category": {
    "title": "Categories",
    "subtitle": "Product category tree",
    "columns": {
      "name": "Name",
      "slug": "Slug",
      "parent": "Parent",
      "productCount": "Products",
      "isActive": "Active"
    },
    "actions": {
      "create": "Create Category",
      "edit": "Edit",
      "delete": "Delete",
      "reorder": "Reorder",
      "moveTo": "Move To"
    },
    "fields": {
      "name": "Name",
      "slug": "Slug",
      "parent": "Parent Category",
      "description": "Description",
      "seoTitle": "SEO Title",
      "seoDescription": "SEO Description",
      "image": "Image"
    },
    "errors": {
      "duplicateSlug": "A category with this slug already exists",
      "hasChildren": "Cannot delete — category has subcategories",
      "circularParent": "A category cannot be its own ancestor"
    },
    "views": {
      "all": "All",
      "active": "Active",
      "inactive": "Inactive",
      "topLevel": "Top-level only"
    },
    "page": {
      "subtitle": "Manage the 2-level category tree shown in the storefront catalog and the blueprint admin sidebar.",
      "filterViewsAria": "Filter views",
      "treeHeading": "Tree",
      "itemCount": "{{count}} items",
      "loadError": "Failed to load categories.",
      "retry": "Retry",
      "reorderFailed": "Reorder failed"
    },
    "detailPanel": {
      "emptySelect": "Select a category from the tree, or click \"+ Category\" to add one.",
      "nameRequired": "Name (English) is required.",
      "created": "Category created.",
      "saved": "Category saved.",
      "saveFailed": "Save failed.",
      "deleted": "\"{{name}}\" deleted.",
      "cannotDeleteTitle": "Cannot delete category",
      "cannotDeleteBody": "This category still has blueprints assigned.",
      "deleteFailed": "Delete failed.",
      "newCategory": "New category",
      "categoryFallback": "Category",
      "idLabel": "ID: {{id}}",
      "nameEnLabel": "Name (English)",
      "nameEnPlaceholder": "T-Shirts",
      "nameViLabel": "Name (Vietnamese)",
      "nameViPlaceholder": "Áo thun",
      "nameFrLabel": "Name (French, optional)",
      "nameFrPlaceholder": "T-shirts",
      "slugLabel": "URL slug",
      "slugPlaceholder": "t-shirts",
      "slugHint": "Lowercase, kebab-case, unique within the same parent level.",
      "topLevelOption": "— Top-level —",
      "depthHint": "Maximum depth is 2 levels (top-level → child only).",
      "statusLabel": "Status",
      "aliasLabel": "Alias (search alternate, optional)",
      "aliasPlaceholder": "Tees, Apparel Tops",
      "shortDescLabel": "Short description (optional)",
      "shortDescPlaceholder": "Soft cotton tees with all-over print",
      "imageLabel": "Tile image (optional)",
      "imageHelper": "PNG / JPEG / SVG ≤ 5 MB",
      "saveBtn": "Save changes",
      "cancel": "Cancel",
      "deleteConfirmTitle": "Delete category?",
      "deleteConfirmPrefix": "Deleting \"",
      "deleteConfirmSuffix": "\" is reversible from the soft-delete log, but blueprints currently assigned to this category will block the operation."
    },
    "seoForm": {
      "legend": "SEO",
      "defaultHint": "Default: \"{{value}}\".",
      "canonicalLabel": "Canonical URL (optional)",
      "googleIndexLabel": "Allow Google to index this category",
      "keywordsLabel": "Meta keywords (optional)",
      "keywordsPlaceholder": "t-shirt, custom apparel, print on demand",
      "keywordsHint": "Comma-separated terms (used by some search engines).",
      "descriptionLabel": "Meta description"
    },
    "treeView": {
      "collapse": "Collapse",
      "expand": "Expand",
      "dragToReorder": "Drag to reorder within level",
      "addSub": "+ Sub",
      "empty": "No categories yet. Click \"+ Category\" to add one.",
      "treeAria": "Category tree"
    },
    "list": {
      "pageTitle": "Category & Collection",
      "pageSubtitle": "Manage your product category schema, parents, child structures, and active catalog channels.",
      "tabCategory": "Category",
      "tabCollection": "Collection",
      "searchPlaceholder": "Search categories...",
      "searchAria": "Search categories",
      "filterStatusAria": "Filter by status",
      "filterStatusAll": "Status: All",
      "filterDisplayAria": "Filter by display",
      "filterDisplayAll": "Display: All",
      "statusActive": "Active",
      "statusInactive": "Inactive",
      "displayOn": "On",
      "displayOff": "Off",
      "colName": "Name",
      "colImage": "Image",
      "colLastUpdate": "Last update",
      "colUpdatedBy": "Updated by",
      "colStatus": "Status",
      "colDisplay": "Display",
      "colActions": "Actions",
      "dragColumnAria": "Reorder",
      "expand": "Expand",
      "collapse": "Collapse",
      "statusToggleAria": "Toggle status for {{name}}",
      "displayToggleAria": "Toggle homepage display for {{name}}",
      "editAria": "Edit {{name}}",
      "viewProductsAria": "View products in {{name}}",
      "showingRange": "Showing {{from}}–{{to}} of {{total}} categories",
      "empty": "No categories match these filters.",
      "toggleFailed": "Could not save the change.",
      "rowsPerPage": "Rows per page:",
      "paginationAria": "Pagination",
      "prevPage": "Previous page",
      "nextPage": "Next page",
      "colCreatedAt": "Created",
      "toggleSaved": "Change saved.",
      "working": "Saving…",
      "dragToReorder": "Drag to reorder within the same level",
      "reorderSaved": "Order updated."
    },
    "form": {
      "createTitle": "Create Category",
      "editTitle": "Edit Category",
      "breadcrumbAria": "Breadcrumb",
      "crumbBlueprint": "Blueprint",
      "crumbCreate": "Create",
      "crumbEdit": "Edit",
      "basicInfo": "Basic Information",
      "nameLabel": "Name",
      "namePlaceholder": "Enter category name",
      "slugLabel": "Slug",
      "slugPlaceholder": "Automatically generated",
      "slugHelper": "Slug is automatically generated from the Category Name and is used for URL generation.",
      "aliasLabel": "Alias",
      "aliasPlaceholder": "Enter display name",
      "imageLabel": "Image",
      "imageHelper": "Max 5MB. PNG, JPG, or WebP.",
      "imageRemove": "Remove",
      "shortDescLabel": "Short Description",
      "shortDescPlaceholder": "Describe your category in detail for catalog purposes...",
      "parentLabel": "Parent Category",
      "parentNone": "None (Top Level)",
      "parentHelper": "Only Level 1 categories can be selected as the parent category.",
      "productsHeading": "Products",
      "productsEmptyTitle": "No product selected",
      "productsEmptyBody": "Select products to link them to this specific category.",
      "productsSelected": "{{count}} Products Selected",
      "productsSelectedBody": "These products are linked specifically to this category.",
      "selectProducts": "Select Products",
      "manageProducts": "Manage Products",
      "seoHeading": "SEO Settings",
      "seoSubtitle": "Optimize how this category appears in search engines.",
      "seoTitleLabel": "SEO Title",
      "seoTitlePlaceholder": "Enter SEO title",
      "seoTitleHelper": "If left empty, the system may automatically use the Alias.",
      "canonicalLabel": "Canonical URL",
      "canonicalPlaceholder": "https://example.com/category/...",
      "canonicalHelper": "Preferred URL used by search engines to prevent duplicate content.",
      "googleIndexLabel": "Google Index",
      "metaKeywordsLabel": "Meta Keywords",
      "metaKeywordsPlaceholder": "Enter keyword and press Enter",
      "metaKeywordRemove": "Remove keyword {{keyword}}",
      "metaDescriptionLabel": "Meta Description",
      "metaDescriptionPlaceholder": "Enter short summary for search engines...",
      "metaDescriptionHelper": "Recommended length: 150–160 characters.",
      "metaDescriptionCounter": "{{count}} / {{max}} characters",
      "stateDrafted": "All changes drafted",
      "stateSaved": "All changes saved",
      "cancel": "Cancel",
      "save": "Save",
      "saving": "Saving…",
      "saveCategory": "Save Category",
      "saveChanges": "Save Changes",
      "savedCreate": "Category created.",
      "savedEdit": "Category saved.",
      "saveFailed": "Save failed.",
      "loadError": "Failed to load this category.",
      "errors": {
        "nameRequired": "Please enter the category name.",
        "nameDuplicate": "The category name already exists. Please enter a different name.",
        "aliasRequired": "Please enter the alias.",
        "canonicalInvalid": "The Canonical URL is invalid.",
        "metaDescriptionTooLong": "The Meta Description exceeds the maximum allowed length.",
        "parentMustBeLevel1": "Only Level 1 categories can be selected as the parent category.",
        "hasChildren": "This has {{count}} sub-item(s) and cannot become a child of another. Move them first.",
        "productsRequired": "Select at least one product."
      },
      "imageUpload": "Upload Image",
      "imageUploading": "Uploading…",
      "imageChange": "Change",
      "imageTypeError": "Only PNG, JPG or WebP images are allowed.",
      "imageSizeError": "Image is too large — maximum {{max}}.",
      "imageUploadError": "Image upload failed.",
      "loadingOptions": "Loading…",
      "parentLockedHelper": "This has {{count}} sub-item(s), so it cannot become a child of another — the tree is limited to 2 levels. Move them first."
    },
    "products": {
      "dialogTitle": "Select Products",
      "dialogSubtitle": "Search and select products to link to this category.",
      "searchPlaceholder": "Search products...",
      "filterStatusAria": "Filter products by status",
      "filterStatusAll": "Status: All",
      "statusActive": "Active",
      "statusDraft": "Draft",
      "statusInactive": "Inactive",
      "showSelectedOnly": "Show selected only",
      "selectAllOnPage": "Select all products on this page",
      "selectRowAria": "Select {{name}}",
      "colImage": "Image",
      "colName": "Product Name",
      "colBlueprint": "Blueprint",
      "colSkuCount": "SKU Count",
      "colStatus": "Status",
      "skuCount": "{{count}} SKUs",
      "showingRange": "Showing {{from}}–{{to}} of {{total}} products",
      "selectedCount": "{{count}} selected",
      "empty": "No products match these filters.",
      "loadError": "Failed to load products.",
      "status": {
        "Active": "Active",
        "Draft": "Draft",
        "Inactive": "Inactive"
      },
      "takenBy": "Already in “{{category}}”",
      "takenByUnnamed": "Already in another category"
    }
  },
  "blueprint": {
    "title": "Blueprints",
    "subtitle": "Product blueprints (templates)",
    "columns": {
      "name": "Name",
      "category": "Category",
      "techniques": "Techniques",
      "basePrice": "Base Price",
      "isActive": "Active",
      "nameCode": "Name/Code",
      "status": "Status",
      "location": "Location",
      "publishTime": "Publish Time",
      "creator": "Creator",
      "lastUpdated": "Last Updated",
      "vendors": "Vendors",
      "source": "Source",
      "activeAction": "On sale",
      "actions": "Actions"
    },
    "actions": {
      "create": "Create Blueprint",
      "edit": "Edit",
      "duplicate": "Duplicate",
      "archive": "Archive",
      "import": "Import",
      "export": "Export",
      "exporting": "Exporting…"
    },
    "detail": {
      "tabs": {
        "info": "Information",
        "variants": "Variants",
        "techniques": "Techniques",
        "pricing": "Pricing",
        "addOns": "Add-ons",
        "media": "Media",
        "seo": "SEO"
      }
    },
    "wizard": {
      "title": "Create blueprint",
      "subtitle": "3-step wizard. Submitting routes the blueprint to the Product Approval queue for maker-checker review.",
      "steps": {
        "information": "1. Information",
        "attributes": "2. Attributes",
        "preview": "3. Preview"
      },
      "type": {
        "label": "Type",
        "locked": "Product (locked)"
      },
      "productCode": "Product Code",
      "productCodeHint": "3-12 uppercase letters or digits.",
      "productName": "Product Name (EN)",
      "slug": "Slug",
      "slugHint": "Auto-derived from name; edit to override.",
      "category": "Category",
      "collections": "Collections",
      "technology": "Technology (multi-select)",
      "productionType": {
        "label": "Production type",
        "printing": "Printing",
        "embroidery": "Embroidery"
      },
      "processingTime": {
        "label": "Processing time (days)",
        "fromDays": "From",
        "toDays": "To"
      },
      "scheduledPublish": "Publish at",
      "scheduledPublishHint": "Leave empty for immediate publish on approval.",
      "templates": "Blueprint Templates",
      "templatesHint": "Blueprint-level templates cascade to all variants without an explicit override.",
      "images": "Images",
      "imagesDrop": "Drop images here or click to select",
      "imagesAccept": "JPEG / PNG / WEBP — up to 10 images, 5+ required for publish.",
      "description": "Description",
      "guideline": "Guideline",
      "videoUrl": "Video URL",
      "videoUrlHint": "Must be a YouTube or Vimeo URL.",
      "attributes": {
        "title": "SKU generator",
        "subtitle": "Pick options + values, then expand cartesian product.",
        "addOption": "Add option",
        "generate": "Generate SKU rows",
        "preview": "Preview"
      },
      "sku": {
        "table": "SKU table",
        "addBlank": "Add blank SKU",
        "code": "SKU",
        "attributes": "Attributes",
        "weight": "Weight (g)",
        "dim": {
          "l": "L",
          "w": "W",
          "h": "H"
        },
        "templates": "Templates"
      },
      "preview": {
        "information": "Information",
        "skuTable": "SKU table",
        "publishNotReady": "Image count is below 5. Approver will block publish until 5+ images are uploaded.",
        "submitNote": "Submitting routes this blueprint to the Product Approval queue (admin self-create). A second admin must approve before publish."
      },
      "actions": {
        "cancel": "Cancel",
        "back": "Back",
        "next": "Next",
        "submit": "Submit for approval",
        "submitting": "Submitting…"
      },
      "create": {
        "pageSubtitle": "Submitting routes this blueprint to the Product Approval queue for maker-checker review.",
        "stepCounter": "Step {{current}} of {{total}}",
        "stepperAria": "Wizard progress",
        "steps": {
          "information": "Information",
          "attributes": "Attributes",
          "logistics": "Logistics",
          "settings": "Settings",
          "preview": "Preview"
        },
        "actions": {
          "continue": "Continue ›",
          "goBack": "‹ Go Back",
          "submitForApproval": "Submit for approval",
          "apply": "Apply",
          "creating": "Creating…",
          "addLocation": "+ Add Location",
          "addVendor": "+ Add Vendor",
          "save": "Save"
        },
        "type": {
          "label": "Type:",
          "product": "Product",
          "cannotChange": "(Cannot change after creation)"
        },
        "checking": "Checking availability…",
        "code": {
          "invalid": "3-12 uppercase letters or digits.",
          "taken": "This Blueprint Code is already in use — pick another.",
          "available": "Blueprint Code available.",
          "placeholder": "Enter product code"
        },
        "slug": {
          "taken": "A product with this name (slug \"{{slug}}\") already exists — pick a different name."
        },
        "fields": {
          "blueprintCode": "Code",
          "blueprintName": "Name",
          "blueprintNamePlaceholder": "Enter product name",
          "skuType": "SKU Type",
          "category": "Category",
          "categoryPlaceholder": "Select a category",
          "categoryRequired": "Category is required",
          "collection": "Collection",
          "productionType": "Type",
          "technology": "Technique",
          "processingTime": "Processing Time",
          "publishTime": "Publish Time",
          "description": "Description",
          "guideline": "Guideline",
          "videoUrl": "Video URL",
          "images": "Images",
          "uploadedThumbnails": "Uploaded thumbnails",
          "chargeForEmbroidery": "Charge for Embroidery",
          "maxEmbroideryColors": "Max Embroidery Colors",
          "youtubeVideoUrl": "Youtube Video URL",
          "technologyRequired": "Technology is a required field",
          "processingTimeRequired": "Processing time is a required field",
          "processingTimeInverted": "The From day count must be less than the To day count",
          "blueprintNameRequired": "Blueprint name is a required field",
          "blueprintCodeRequired": "Blueprint Code is a required field",
          "imagesRequired": "Images is a required field — add {{count}} more (minimum {{min}})",
          "searchCategory": "Search categories…",
          "searchingCategories": "Searching…",
          "noCategoryOptions": "No active category matches."
        },
        "skuType": {
          "product": "Product",
          "accessory": "Accessories"
        },
        "category": {
          "quickCreateAria": "Quick-create new category",
          "quickCreateTitle": "Quick-create category"
        },
        "collection": {
          "loading": "Loading collections…",
          "searchPlaceholder": "Search collection...",
          "dropdownLoading": "Loading…",
          "emptyHint": "No collections. Use the “+” button to create one.",
          "noMatch": "No collections match “{{query}}”.",
          "quickCreateAria": "Quick-create new collection",
          "quickCreateTitle": "Quick-create collection",
          "removeAria": "Remove collection {{name}}"
        },
        "productionType": {
          "aria": "Production Type",
          "printing": "Print",
          "embroidery": "Embroidery",
          "cutting": "Cutting",
          "blank": "Blank"
        },
        "technology": {
          "hint": "Please select at least one technology"
        },
        "processing": {
          "to": "To",
          "days": "days",
          "from": "From",
          "businessDays": "business days",
          "figmaHint": "Estimated production time in business days."
        },
        "publish": {
          "hint": "Schedule publish time"
        },
        "videoUrl": {
          "hint": "Enter video URL (YouTube, etc.)",
          "invalid": "Must be a YouTube or Vimeo URL.",
          "placeholder": "https://youtube.com/watch?v=...",
          "figmaHint": "Bring your photo to life with a 5 to 15 second video — it could help you drive more sales!"
        },
        "images": {
          "dropHint": "Drag & drop images here, or",
          "uploadAria": "Upload mockup images",
          "uploading": "Uploading…",
          "uploadButton": "Upload Images",
          "helper": "JPEG / PNG — up to 10 images. At least {{min}} images required",
          "helperMissing": " ({{count}} more needed).",
          "previewAria": "Preview {{name}}",
          "reorderTitle": "Drag the card to reorder",
          "remove": "Remove",
          "empty": "No images uploaded yet",
          "emptyHint": "Thumbnails will appear here",
          "needMore": "{{count}} more image(s) needed before publish gate clears.",
          "primaryBadge": "Primary",
          "figmaHelper": "Upload between {{min}}–{{max}} images. The first image will be displayed as the primary product photo. You can drag to reorder."
        },
        "location": {
          "title": "Location & Vendor",
          "subtitle": "Select Location & Vendor",
          "emptyBound": "No locations bound yet. Click \"+ Add Location\" to pick from the Fulfillment Locations catalog.",
          "vendors": "Vendors",
          "selectDefaultHint": "Select default vendor with the radio.",
          "markDefaultAria": "Mark as default vendor",
          "pickVendorFirstTitle": "Pick a vendor before marking default",
          "minVendorTitle": "At least one vendor required per location",
          "removeVendorTitle": "Remove vendor",
          "vendorListEmpty": "At least one vendor required per location.",
          "pickDefaultVendor": "Pick a vendor for the default radio.",
          "defaultLocation": "Default Location",
          "addLocation": "Add Location",
          "noneExist1": "No locations exist yet. Create one on the",
          "fulfillmentLocationsLink": "Fulfillment Locations",
          "noneExist2": "admin page first.",
          "perSkuNote": "Per-SKU location & vendor binding is configured on the Blueprint detail page after creation.",
          "selectVendor": "Select vendors",
          "noLocationOptions": "No fulfillment locations available.",
          "noVendorOptions": "No vendors available.",
          "vendorSharePctAria": "Order share for {{vendor}}, in percent",
          "pctSumOk": "Σ 100% — split is valid",
          "pctSumInvalid": "Σ {{sum}}% — shares must total 100%",
          "searchVendor": "Search vendors…",
          "searchingVendors": "Searching vendors…",
          "pctSumUnbound": "Σ {{sum}}% — part of it belongs to a vendor no longer selected"
        },
        "selectLocation": "— Select Location —",
        "selectVendor": "Select vendor…",
        "removeLocationAria": "Remove location",
        "removeVendorAria": "Remove vendor",
        "tiktok": {
          "title": "TikTok Config",
          "subtitle": "Tick each vendor that ships via TikTok.",
          "emptyHint": "Pick a Location & Vendor above to map vendors for TikTok shipping.",
          "noVendor": "No vendor selected",
          "defaultBadge": "Default"
        },
        "skuList": {
          "title": "SKU List",
          "count": "{{count}} SKU",
          "import": "Import Excel",
          "export": "Export Excel",
          "filterBy": "Filter by:",
          "noAttrGroups": "No attribute groups yet — use the generator above.",
          "selectedCount": "{{count}} SKU selected",
          "templateLabel": "Template:",
          "bulkTemplateAria": "Bulk assign templates",
          "skuTypeLabel": "SKU Type:",
          "tierPriceLabel": "Tier Price:",
          "bulkEditPrices": "Bulk Edit Prices",
          "deselect": "Deselect",
          "empty": "No SKUs yet. Pick options on the left — the table auto-fills.",
          "pricesNote": "Prices in cents (e.g. 1099 = $10.99). Empty cells skip that variant×tier pair. Logistics (weight / dimensions / per-service shipping fees) are edited on the Blueprint detail page post-create.",
          "clearFilters": "Clear filters",
          "noFilterMatch": "No SKUs match the selected filters.",
          "exportSuccess": "Exported {{count}} SKUs",
          "exportEmptyTemplate": "No SKUs yet — exported an empty template. Fill it and re-import.",
          "exportError": "Export failed",
          "exportHint": "Download the current SKU list (.xlsx): SKU, attributes, type, per-tier prices, per-service shipping fees, logistics and state.",
          "importDone": "Updated {{updated}} SKU(s), skipped {{skipped}}",
          "importError": "Import failed — check the file matches the exported format",
          "importHint": "Import an .xlsx/.csv to create or update SKUs. Attribute values must already exist in the catalog (Products → Options); prices and shipping fees are in $.",
          "importEmpty": "The file has no rows.",
          "importNoMatch": "No SKU matched. Import only updates SKUs already generated from options — Export first to get the exact template, edit it, then re-import.",
          "importOptionsLoading": "Option catalog not loaded yet — wait a moment and try the import again.",
          "importCreated": "Imported {{created}} new, updated {{updated}}, skipped {{skipped}} SKU(s)",
          "importUnresolved": "No SKU imported — these attribute values are not in the catalog: {{missing}}. Add them under Products → Options first.",
          "importNoRows": "No SKU imported — check the SKU + Attributes columns match the exported template.",
          "importTemplatesUnresolved": "Unknown template codes ignored: {{codes}}. Use the exact template CODE (Export shows them).",
          "optionFilterLabel": "Option:",
          "rowsPerPage": "Rows per page:",
          "showingRange": "Showing {{from}}–{{to}} of {{total}} SKUs",
          "prevPage": "Previous page",
          "nextPage": "Next page",
          "vendorFilterLabel": "Vendor:",
          "allVendors": "All Vendors",
          "allOptions": "All Options",
          "bulkEdit": "Edit",
          "bulkAssignTemplate": "Assign Template",
          "bulkSetDimension": "Set Dimension",
          "copyPricesPrompt": "This location has no prices yet.",
          "copyPricesFrom": "Copy from {{from}}",
          "copyPricesDone": "Prices copied from {{from}}.",
          "bulkMarkSmall": "Mark Small",
          "bulkUnmarkSmall": "Unmark Small"
        },
        "skuTable": {
          "selectAllAria": "Select all SKUs",
          "code": "SKU",
          "attributes": "Attributes",
          "templates": "Template",
          "type": "Type",
          "selectRowAria": "Select SKU {{sku}}",
          "codeReadonlyTitle": "SKU generated from option values (read-only)",
          "editTemplatesAria": "Edit templates for this SKU",
          "priceMonotonicTitle": "{{tier}} ({{current}}) must stay below {{higherTier}} ({{higherValue}}).",
          "toggleActiveTitle": "SKU is Inactive — click to set Active again",
          "toggleInactiveTitle": "SKU is Active — click to set Inactive",
          "inactive": "Inactive",
          "active": "Active",
          "action": "Action",
          "vendor": "Vendor",
          "dimension": "Dimension",
          "status": "Status",
          "assign": "Assign",
          "set": "Set",
          "view": "View",
          "viewCount": "View ({{count}})",
          "templatesCount": "Template ({{count}})",
          "dimensionAria": "Set dimensions for {{sku}}",
          "priceZeroTitle": "Price must be greater than 0.",
          "tierWithUnit": "{{tier}} ($)",
          "priceRequiredTitle": "A price is required for this tier.",
          "dimensionFormat": "Weight x H x W x L",
          "dimensionValueAria": "Weight {{weight}} g, box {{height}} x {{width}} x {{length}} in",
          "small": "Small",
          "smallAria": "Mark {{sku}} as a small product",
          "dimensionValueWithUnit": "{{weight}} g x {{height}} in x {{width}} in x {{length}} in"
        },
        "skuTypeLabels": {
          "product": "Product",
          "small_product": "Small product",
          "accessory": "Accessories"
        },
        "logistics": {
          "descriptionExtra": "— Active blueprints require these fields at approval time; incomplete logistics will block the flip to Active.",
          "exportSuccess": "Exported {{count}} rows",
          "exportError": "Export failed",
          "exportHint": "Download logistics (.xlsx): SKU, weight, dimensions with units and per-service shipping fees ($).",
          "importEmpty": "The file has no rows.",
          "importNoMatch": "No SKU matched — Export first to get the template, fill it, then re-import.",
          "importDone": "Updated {{updated}}, skipped {{skipped}} row(s)",
          "importError": "Import failed — check the file matches the exported format",
          "importFeeInvalid": "Shipping fee ignored in: {{columns}} — must be a number between 0 and 10000.",
          "importWrongLocation": "This file holds rates for {{sheet}}, but the {{active}} tab is open. Switch to that location's tab, then import.",
          "importHint": "Import an .xlsx/.csv to bulk-update weight, dimensions (with units) and shipping fees, matched by SKU."
        },
        "preview": {
          "logisticsBanner": "⚠ Logistics (weight + length/width/height + per-service shipping fees) are incomplete. You can still save this as a draft, but the approver will block the flip to Active until logistics are complete. Finish them in the Logistic block above before submitting as Active.",
          "information": "Information",
          "nameEn": "Name (EN)",
          "slug": "Slug",
          "collections": "Collections",
          "technologies": "Technologies",
          "selectedCount": "{{count}} selected",
          "processingTime": "Processing time",
          "daysRange": "{{from}}–{{to}} days",
          "publishAt": "Publish at",
          "immediate": "Immediate on approval",
          "templates": "Templates",
          "images": "Images",
          "publishReady": "publish-ready",
          "needFive": "need 5+",
          "skuTable": "SKU table",
          "skuSummary": "{{skus}} SKU(s) — {{entries}} price entries.",
          "noSkus": "No SKUs yet — pick options in the Options block to generate them before saving.",
          "noPricesWarn": "⚠ No prices set. The approver will see blank pricing — fill them in the Pricing block above, or save and edit pricing on the Blueprint detail page after approval.",
          "imageCountWarn": "⚠ Image count is {{count}}/5. The maker-checker approver will block publish until 5+ images are uploaded.",
          "noAreasBanner": "No SKU has a Template assigned, so this product will have no print areas — it cannot be put on sale until at least one area exists. Assign a Template on the Attributes step, or add print areas later from the product page.",
          "submitNote": "Submitting routes this blueprint to the Product Approval queue (admin self-create). A second admin must approve before publish."
        },
        "templatePicker": {
          "aria": "Select template",
          "title": "Select Template",
          "searchPlaceholder": "Search templates…",
          "empty": "No blueprint templates available. Add templates on the catalog page first.",
          "noMatch": "No templates match \"{{query}}\".",
          "select": "Select",
          "deselectAria": "Remove {{name}}"
        },
        "vendorPicker": {
          "aria": "Assign vendor/location to SKU",
          "title": "Vendor / Location — {{sku}}",
          "titleBulk": "Vendor / Location — {{count}} SKU(s)",
          "description": "Assign location + vendor to the SKU. The % order column splits per location: each location must total 100 to split orders proportionally; leave blank = routing picks the highest-scoring vendor.",
          "empty1": "No locations yet. Click",
          "empty2": "to get started.",
          "location": "Location",
          "default": "Default",
          "vendor": "Vendor",
          "orderPercent": "% of orders",
          "noVendor": "No vendors yet. Click \"+ Add Vendor\".",
          "pickLocationFirst": "Pick a location first",
          "sumNoSplit": "No split — routing picks the highest-scoring vendor",
          "sumValid": "Valid — split by %",
          "sumInvalid": "This location's total % must equal 100 (or leave all blank)",
          "sumNeed100Suffix": " — must equal 100",
          "locationsIncomplete": "{{count}} location(s) not at 100% — cannot save",
          "percentValid": "% valid — split by location",
          "weightWarnTitle": "Each location must total 100%, or leave all blank (no split). Cannot Apply while a location is incomplete.",
          "applyInvalidTitle": "A location's % is invalid (≠100 and ≠0) — set it to 100 or clear all %"
        },
        "bulkPrice": {
          "aria": "Bulk edit tier prices",
          "title": "Bulk Edit Prices — {{count}} SKU(s)",
          "hint": "Leave a tier blank to keep its current per-SKU price. Filled values overwrite every selected SKU.",
          "noTiers": "No pricing tiers configured.",
          "pricePlaceholder": "e.g. 1099 (= $10.99)",
          "monotonicWarn": "⚠ {{tier}} ({{current}}) ≥ {{higherTier}} ({{higherValue}}). Higher tiers must stay above lower tiers."
        },
        "imagePreview": {
          "aria": "Preview {{name}}",
          "ariaDefault": "Image preview",
          "closeAria": "Close preview"
        },
        "categoryModal": {
          "aria": "Quick Add Category",
          "title": "Quick Add Category",
          "code": "Category Code",
          "name": "Category Name",
          "namePlaceholder": "T-Shirt",
          "parent": "Parent Category",
          "rootCategory": "Root Category",
          "submit": "Create Category"
        },
        "collectionModal": {
          "aria": "Create new collection",
          "title": "Create new collection",
          "nameEn": "Name (EN)",
          "nameEnPlaceholder": "e.g. Spring 2026",
          "nameVi": "Name (VI)",
          "nameViPlaceholder": "e.g. Mùa xuân 2026",
          "slug": "Slug",
          "slugPlaceholder": "auto-derived from name",
          "slugHint": "Auto-derived from name; edit to override.",
          "submit": "Create collection"
        },
        "confirm": {
          "discard": "Discard unsaved draft and leave?"
        },
        "addons": {
          "heading": "Add-ons",
          "description": "Optional extras a merchant can attach when ordering this product.",
          "enable": "Enable add-ons",
          "disabledHint": "Add-ons are off for this product. Turn them on to pick which ones apply.",
          "addLabel": "Add an add-on",
          "selectAddon": "Select an add-on…",
          "noMore": "No more add-ons available",
          "loading": "Loading add-ons…",
          "add": "Add",
          "remove": "Remove",
          "empty": "No add-ons selected yet.",
          "colName": "Name",
          "colMode": "Mode",
          "colRequired": "Required",
          "colActions": "Actions",
          "requiredSuffix": ", required",
          "yes": "Yes",
          "no": "No",
          "linkedOnCreateHint": "These are linked once the product is created. You can change them later from the product’s Settings step."
        },
        "toast": {
          "categoryNameRequiredTitle": "Category Name required",
          "categoryNameRequiredDesc": "Enter the category name.",
          "categoryCodeRequiredTitle": "Category Code required",
          "categoryCodeRequiredDesc": "Enter a code (e.g. DM-001).",
          "categoryCodeInvalidTitle": "Invalid Category Code",
          "categoryCodeInvalidDesc": "Code must contain letters or digits.",
          "categoryCreateFailTitle": "Create category failed",
          "categoryCreatedTitle": "Category created",
          "categoryCreatedDesc": "{{name}} ready to use.",
          "networkError": "Network error",
          "collectionNameRequiredTitle": "Name required",
          "collectionNameRequiredDesc": "Enter the collection name (EN).",
          "collectionCreateFailTitle": "Create collection failed",
          "collectionCreatedTitle": "Collection created",
          "collectionCreatedDesc": "{{name}} ready to use.",
          "uploadFailedReason": "upload failed",
          "more": "more",
          "skippedUnsupportedTitle": "Skipped {{count}} unsupported file(s)",
          "skippedUnsupportedDesc": "Only JPEG / PNG allowed. Skipped: {{files}}",
          "imageCapTitle": "Image cap reached",
          "imageCapDesc": "Only 10 images allowed at create time. Skipped {{count}} file(s).",
          "uploadFailedTitle": "{{count}} upload(s) failed",
          "step1ImagesDesc": "At least {{min}} mockup images required (currently {{current}}). Add more images before continuing.",
          "step1FixFields": "Fix the highlighted fields before continuing.",
          "step1IncompleteTitle": "Details block incomplete",
          "skuUniqueDesc": "Each SKU must be unique and non-empty.",
          "skuAddOneDesc": "Add at least one SKU before continuing.",
          "skuMissingTemplateDesc": "{{count}} SKU(s) missing a Template. Use the per-row + button or the bulk Template action.",
          "step2IncompleteTitle": "Options block incomplete",
          "locationRequiredTitle": "Location & Vendor required",
          "locationRequiredDesc": "Bind at least one Location with a Vendor before continuing. A blueprint cannot be created without a Location & Vendor.",
          "logisticsIncompleteTitle": "Logistics incomplete",
          "logisticsIncompleteDesc": "Some SKUs are missing weight / dimensions / per-service shipping fees. You can continue as a draft — validation runs at the approval step.",
          "createFailTitle": "Create blueprint failed",
          "submittedTitle": "Submitted for approval",
          "submittedDesc": "Blueprint is now in the Product Approval queue.",
          "importTitle": "Import not wired yet",
          "importDesc": "Wizard-side Import is scheduled for the post-create Blueprint detail page (xlsx).",
          "exportTitle": "Export not wired yet",
          "exportDesc": "Export available from the post-create Blueprint detail page (xlsx).",
          "priceZeroTitle": "Price cannot be 0",
          "priceZeroDesc": "{{count}} price cell(s) are set to 0. Enter a price greater than 0, or clear the cell to leave that tier unpriced.",
          "step1MissingFields": "Please fill in the required fields: {{fields}}.",
          "priceRequiredDesc": "{{count}} price field(s) are empty. Every SKU needs a price for every tier before you can continue.",
          "tierOrderDesc": "{{count}} price cell(s) break the tier ladder — a lower tier must cost less than the tier above it.",
          "optionRowIncomplete": "{{count}} option row(s) are unfinished — pick an option and at least one value, or remove the row."
        },
        "vendorCell": {
          "unassigned": "Unassigned"
        },
        "tocAria": "Blueprint sections",
        "nothingSavedYet": "Nothing saved yet — press Save to create",
        "blocks": {
          "details": "Details",
          "techniques": "Techniques",
          "mockups": "Mockups",
          "options": "Options",
          "locations": "Locations",
          "logistic": "Logistic",
          "review": "Review",
          "pricing": "Pricing",
          "tiktok": "TikTok Shop",
          "areas": "Areas",
          "accessories": "Accessories"
        },
        "blockSubtitles": {
          "techniques": "Configure the production technique for this blueprint.",
          "options": "Select options to generate SKU combinations. Maximum 3 options per blueprint.",
          "locations": "Configure manufacturing locations and assign vendors for this blueprint.",
          "logistic": "Configure shipping and fees for each SKU by location.",
          "review": "Check everything before saving.",
          "pricing": "Configure pricing and templates for each SKU by location.",
          "tiktok": "Optional TikTok Shop settings for this blueprint.",
          "areas": "Pricing configuration for printing/embroidery areas",
          "accessories": "Configure pricing for accessory add-ons and supplementary items."
        },
        "dimensionModal": {
          "aria": "Set dimensions",
          "title": "Set Dimensions",
          "subtitle": "Configure box dimensions for shipping calculation.",
          "unitBox": "Unit Box",
          "boxHeight": "Box Height",
          "boxWidth": "Box Width",
          "boxLength": "Box Length",
          "bulkTarget": "{{count}} SKUs selected"
        },
        "countryTabsAria": "Country",
        "countryTabsEmpty": "Add a location in the Locations block to configure pricing per country.",
        "areas": {
          "selectionMode": "Selection Mode",
          "mode": {
            "multi": "Multi Choice",
            "single": "Single Choice"
          },
          "startChargingFrom": "Start Charging From",
          "startChargingHint": "Pricing applies from this print-area number onward. Must be at least the required quantity.",
          "clampedToRequired": "Raised to {{value}} — that many areas are required, and required areas are never free.",
          "pricingConfig": "Area Pricing Configuration",
          "applySameFee": "Apply same price for all tiers",
          "emptyNeedsTemplate": "No print areas yet. Areas come from the templates assigned to your SKUs — assign a Template in the Pricing block and they appear here.",
          "bulkEdit": "Edit",
          "bulkEditAria": "Edit prices for multiple areas",
          "bulkEditSubtitle": "Edit prices for multiple areas at once.",
          "bulkPrice": "Price",
          "bulkRequired": "Required",
          "bulkDisplay": "Display",
          "bulkEditDone": "Updated {{count}} area(s).",
          "startChargingRequired": "Start Charging From is required — enter 1 or more."
        },
        "accessories": {
          "pricingConfig": "Accessory Pricing Configuration",
          "searchPlaceholder": "Search accessories to add...",
          "searching": "Searching…",
          "noResults": "No accessories match that search.",
          "add": "Add",
          "added": "Added",
          "emptySearchToAdd": "No accessories linked yet. Search above to add one.",
          "scopeFilter": "Search accessories by",
          "scope": {
            "product": "Blueprint",
            "variant": "Variant"
          }
        },
        "breadcrumbAria": "Breadcrumb",
        "crumbBlueprint": "Blueprint",
        "crumbCreate": "Create",
        "chargeForEmbroidery": {
          "yes": "Yes",
          "no": "No"
        },
        "maxEmbroideryColors": {
          "invalid": "Maximum embroidery colors must be an integer greater than 0."
        },
        "toc": {
          "pinTitle": "Pin the section bar while scrolling",
          "unpinTitle": "Unpin the section bar"
        },
        "tocLabels": {
          "mockups": "Mockup"
        }
      }
    },
    "errors": {
      "missingTechnique": "Blueprint must have at least one technique",
      "duplicateName": "A blueprint with this name already exists",
      "loadFailed": "Failed to load blueprints",
      "networkError": "Network error",
      "networkErrorDesc": "Network error - check connection",
      "exportFailed": "Export failed"
    },
    "detailPage": {
      "loading": "Loading blueprint…",
      "errorHeading": "Blueprint detail",
      "backToList": "Back to Blueprints",
      "pricingSummary": "Apply ${{amount}} to {{count}} variant(s) @ {{tier}}",
      "defaultTier": {
        "standard": "Standard",
        "premium": "Premium",
        "enterprise": "Enterprise"
      },
      "errors": {
        "missingId": "Missing blueprint id in URL",
        "loadFailedHttp": "Load failed (HTTP {{status}})",
        "networkCheck": "Network error — check connection",
        "network": "Network error",
        "notFound": "Blueprint not found"
      },
      "header": {
        "code": "Code:",
        "slug": "Slug:",
        "status": "Status:"
      },
      "actions": {
        "viewHistory": "View History",
        "edit": "Edit",
        "cancel": "Cancel",
        "delete": "Delete",
        "deleting": "Deleting…",
        "deleteTitle": "Soft-delete this blueprint (Inactive only)",
        "putOnSale": "Put on sale",
        "takeOffSale": "Take off sale",
        "saving": "Saving…",
        "saveAsDraft": "Save as Draft",
        "saveChange": "Save Change",
        "goBack": "‹ Go Back",
        "continue": "Continue ›"
      },
      "confirm": {
        "deleteBlueprint": "Delete blueprint \"{{name}}\"? This is a soft-delete and can be restored from audit history.",
        "removeVendorMapping": "Remove this vendor mapping?"
      },
      "toast": {
        "httpStatus": "HTTP {{status}}",
        "invalidPriceTitle": "Invalid price",
        "invalidPriceDesc": "Enter a number ≥ 0 (e.g. 19.99)",
        "csvEmptyTitle": "Empty Excel",
        "csvEmptyDesc": "No data rows.",
        "csvInvalidTitle": "Invalid Excel format",
        "csvMissingSku": "Missing SKU column.",
        "importDoneTitle": "Import: {{count}} SKU updated",
        "importPriceChanged": "Prices changed — press Save Change to save (is recorded automatically).",
        "importTemplatesChanged": "Templates updated in the grid — press Save Change to save.",
        "importShippingChanged": "Shipping fees updated in the grid — press Save Change to save.",
        "importStatusChanged": "Status updated.",
        "logisticExportDone": "Exported {{count}} logistic rows",
        "logisticExportFailed": "Logistic export failed",
        "logisticImportFormat": "Unrecognised file — Export the logistic sheet first, fill it, then re-import.",
        "logisticImportWrongLocation": "This sheet is for {{sheet}}, but the {{active}} tab is open. Switch tabs and import again.",
        "logisticImportNoMatch": "No SKU matched — Export first to get the template, fill it, then re-import.",
        "logisticImportDone": "Updated {{updated}}, skipped {{skipped}} logistic row(s) — Save to apply",
        "logisticImportFailed": "Logistic import failed — check the file matches the exported format",
        "importShippingInvalid": "Shipping fee ignored in: {{columns}} — must be a number between 0 and 10000.",
        "pricingChangeFailed": "Pricing change failed",
        "pricingUpdatedTitle": "Pricing updated",
        "pricingUpdatedDesc": "Audit log entry recorded.",
        "cannotDeleteTitle": "Cannot delete",
        "cannotDeleteDesc": "Blueprint must be Inactive before delete.",
        "deleteFailed": "Delete failed",
        "blueprintDeleted": "Blueprint deleted",
        "cannotSaveTitle": "Cannot save",
        "cannotSaveImages": "At least 5 mockup images are required.",
        "saveFailed": "Save failed",
        "blueprintSaved": "Blueprint saved",
        "loadVendorsFailed": "Load vendors failed",
        "missingSelectionTitle": "Missing selection",
        "missingSelectionDesc": "Pick both a vendor and a variant before adding the mapping.",
        "addVendorFailed": "Add vendor failed",
        "vendorMappingAdded": "Vendor mapping added",
        "removeFailed": "Remove failed",
        "vendorMappingRemoved": "Vendor mapping removed",
        "statusChangeFailed": "Status change failed",
        "statusNoTransition": "Status “{{status}}” has no direct transition here — a Pending Approval product moves through the approval queue.",
        "statusChanged": "Status → {{status}}",
        "savePublishFieldsFailed": "Save publish fields failed",
        "publishingFieldsSaved": "Publishing fields saved",
        "saveSeoFailed": "Save SEO failed",
        "seoSaved": "SEO saved",
        "linkAddonFailed": "Link add-on failed",
        "addonLinkedTitle": "Add-on linked",
        "addonLinkedDesc": "{{name}} was assigned to the product.",
        "removeAddonFailed": "Remove add-on failed",
        "addonRemoved": "Add-on removed",
        "savePrintAreasFailed": "Save Print Areas failed",
        "printAreasSaved": "Print Areas saved",
        "reApprovalTitle": "Saved — product taken off sale",
        "reApprovalDesc": "This edit sent the product back for approval, so merchants cannot order it until a checker approves it. Changed: {{fields}}.",
        "reApprovalResubmitTitle": "Saved — resubmitted for approval",
        "reApprovalResubmitDesc": "The product was previously rejected; this edit puts it back in the approval queue. Changed: {{fields}}.",
        "step1IncompleteTitle": "Step 1 is incomplete",
        "step1ImagesDesc": "At least {{min}} mockup images are required — you have {{current}}.",
        "tierOrderTitle": "Tier prices are out of order",
        "tierOrderDesc": "{{current}} is not below {{higherTier}} ({{higherValue}}). A lower tier must cost less than the tier above it.",
        "locationNeedsVendor": "Location \"{{locations}}\" has no vendor. Pick one, or remove the location before saving.",
        "vendorSplitInvalid": "Shares of the % vendors must add up to 100%.",
        "vendorSplitUnbound": "A location still gives a share to a vendor that is no longer selected — re-enter the percentages.",
        "importSkuDataChanged": "Small / dimension updated in the grid — press Save Change to save."
      },
      "info": {
        "blueprintName": "Blueprint name",
        "blueprintCode": "Blueprint Code",
        "locked": "(locked)",
        "slug": "Slug",
        "category": "Category",
        "selectCategory": "Select category...",
        "collections": "Collections",
        "noCollections": "No collections.",
        "productionType": "Production Type",
        "derivedFromTechniques": "Saved production type: {{types}} — derived from the techniques above.",
        "derivedReadOnly": "(derived, read-only)",
        "technology": "Technology",
        "processingTime": "Processing Time",
        "to": "to",
        "days": "days",
        "publishTime": "Publish Time",
        "tags": "Tags (comma-separated)",
        "description": "Description",
        "guideline": "Guideline",
        "videoUrl": "Video URL",
        "videoUrlPlaceholder": "https://youtube.com/watch?v=..."
      },
      "seo": {
        "heading": "SEO",
        "title": "Title",
        "metaDescription": "Meta description",
        "canonicalUrl": "Canonical URL",
        "canonicalUrlError": "canonicalUrl must start with http:// or https://",
        "googleIndex": "Google index",
        "indexInherit": "(inherit)",
        "indexYes": "index (yes)",
        "indexNo": "noindex (no)",
        "metaKeywords": "Meta keywords (comma-separated, max 20)",
        "canonicalUrlPlaceholder": "https://…"
      },
      "images": {
        "label": "Images",
        "editHint": "Click Edit at the top of the page to upload / change images.",
        "dragDrop": "Drag & drop images here, or",
        "uploadAria": "Upload mockup images",
        "uploading": "Uploading…",
        "uploadButton": "Upload Images",
        "acceptHint": "JPEG / PNG — up to 10 images, 5+ required for publish.",
        "moreNeeded": "{{count}} more image(s) needed before publish gate clears.",
        "mockup": "Mockup",
        "reorderHint": "Image #1 is the thumbnail (shown in the list + storefront). Drag to reorder.",
        "mockupAlt": "Mockup {{index}}",
        "thumb": "Thumb",
        "remove": "Remove",
        "emptyTitle": "No images uploaded yet",
        "emptyHint": "Thumbnails will appear here",
        "requiredError": "At least {{min}} mockup images are required to continue — you have {{current}}.",
        "viewImage": "View mockup image {{index}}",
        "viewerAria": "Mockup image preview"
      },
      "attributes": {
        "bindingSummary": "{{locCount}} loc · {{vendorCount}} vendor",
        "notAssigned": "Not assigned",
        "heading": "Attributes",
        "addOnlyHint": "Add an option or a value to create more SKUs. Values already used by existing SKUs cannot be removed.",
        "newSkuNote": "{{added}} new SKU(s) will be created on Save ({{total}} total). Set their prices in the Pricing block afterwards.",
        "lockedHint": "SKU / attributes / variant matrix are locked (immutable after creation).",
        "options": "Options",
        "optionsSummary": "{{skuCount}} SKU · {{bindingCount}} option binding(s)"
      },
      "locationVendor": {
        "heading": "Location & Vendor",
        "removeHint": "Removing a vendor: in-flight orders finish on it; new unassigned orders won't route to the removed vendor (pending_reassignment flow in Order).",
        "noBindingEditable": "No location bound. Click \"+ Add Location\".",
        "noBinding": "No location bound.",
        "location": "Location",
        "defaultParen": "(default)",
        "vendors": "Vendors",
        "noVendor": "No vendor assigned",
        "defaultStarTitle": "★ = default vendor",
        "selectLocation": "— Select Location —",
        "removeLocation": "Remove location",
        "radioDefault": "(radio = default)",
        "selectVendor": "Select vendor…",
        "removeVendor": "Remove vendor",
        "addVendor": "+ Add Vendor",
        "defaultLocation": "Default Location",
        "addLocation": "+ Add Location",
        "shareWithoutVendor": "not selected — still has a share"
      },
      "sku": {
        "listTitle": "SKU List",
        "listSubtitle": "{{count}} SKU · attributes locked, price changes require a reason",
        "bulkEditHint": "Bulk edit: download Template → fill the Templates column (codes, multiple separated by |) + per-tier price → Import → Save Change.",
        "templateBtn": "Template",
        "templateBtnTitle": "Download the Excel template (SKU pre-filled, fill templates + prices then Import)",
        "exportBtn": "Export",
        "exportBtnTitle": "Download a Excel of the current data",
        "importBtn": "Import",
        "filterBy": "Filter by:",
        "noAttributeGroups": "No attribute groups.",
        "selectedCount": "{{count}} SKU selected",
        "templateLabel": "Template:",
        "assignTemplates": "Assign templates",
        "vendorLabel": "Vendor:",
        "assignVendorLocation": "Assign vendor/location",
        "priceLabel": "Price:",
        "bulkEditPrices": "Bulk Edit Prices",
        "deselect": "Deselect",
        "selectAll": "Select all SKUs",
        "colSkuCode": "SKU Code",
        "colAttributes": "Attributes",
        "colTemplates": "Templates",
        "colVendorLocation": "Vendor / Location",
        "selectRow": "Select SKU {{sku}}",
        "removeTemplateAria": "Remove template {{template}} from {{sku}}",
        "editTemplatesAria": "Edit templates for this SKU",
        "splitTitle": "Order split by the configured %",
        "editVendorAria": "Edit vendor/location for this SKU",
        "footerNote": "Adding an option or a value creates new SKUs on Save; values already in use cannot be removed. Stock is managed on the dedicated Stock page.",
        "allOptions": "All options",
        "clearFilters": "Clear",
        "filterNoMatch": "No SKU matches this filter.",
        "exportExcel": "Export Excel",
        "importExcel": "Import Excel"
      },
      "priceLoc": {
        "label": "Price by location",
        "badgeTitle": "Base tab = price applied to all locations (default). Other location tabs = price specific to that location (overrides base). Saved on Save Change.",
        "badge": "base + per-location override · saved on Save Change",
        "baseSuffix": "(base)",
        "bulk": "Bulk:",
        "copyFrom": "Copy price from location…"
      },
      "logistics": {
        "colSku": "SKU",
        "colWeight": "Weight (g)",
        "colDimensions": "L×W×H (cm)"
      },
      "preview": {
        "information": "Information",
        "blueprintCode": "Blueprint Code",
        "nameEn": "Name (EN)",
        "slug": "Slug",
        "category": "Category",
        "collections": "Collections",
        "productionTypes": "Production types",
        "processingTime": "Processing time",
        "daysRange": "{{from}}–{{to}} days",
        "tags": "Tags",
        "images": "Images",
        "status": "Status",
        "skusHeading": "SKUs ({{count}})",
        "skusNote": "{{count}} variant(s). Change prices / logistics in the earlier steps, then press Save Change.",
        "imageWarning": "⚠ Image count {{count}}/5 — 5+ images required before saving.",
        "editHint": "Click \"Edit\" at the top of the page to make changes.",
        "noSkus": "No SKUs generated yet."
      },
      "addons": {
        "heading": "Add-ons",
        "description": "Optional feature. Enable to assign shared add-ons to the product (one add-on can be assigned to multiple blueprints).",
        "enable": "Enable add-ons",
        "disabledHint": "Add-ons are off. Toggle on to select add-ons for the product.",
        "addLabel": "Add an add-on",
        "noMore": "— No more add-ons to link —",
        "selectAddon": "— Select add-on —",
        "requiredSuffix": ", required",
        "saving": "Saving…",
        "add": "Add",
        "loading": "Loading add-ons…",
        "empty": "No add-ons assigned to this product yet.",
        "colName": "Name",
        "colMode": "Mode",
        "colRequired": "Required",
        "colStatus": "Status",
        "colActions": "Actions",
        "yes": "Yes",
        "no": "No",
        "remove": "Remove",
        "footerNoteBefore": "Create new add-ons on the ",
        "footerNoteAfter": " page. Here you only assign existing add-ons."
      },
      "accessoryLinks": {
        "title": "Linked accessories",
        "subtitle": "Link accessory products sold together with this blueprint. When bought bundled, an accessory charges only its extra shipping fee if the toggle is on; standalone purchases always pay full shipping.",
        "addLabel": "Link an accessory",
        "selectAccessory": "— Select accessory —",
        "add": "Link",
        "empty": "No accessories linked to this blueprint yet.",
        "colName": "Accessory",
        "colChoiceMode": "Choice",
        "colRequired": "Required",
        "colChargeFromN": "Charge from",
        "colMinMax": "Min–Max qty",
        "colChargeShipping": "Bundled shipping",
        "colActions": "Actions",
        "chargeShippingHint": "Charge additional shipping when bundled",
        "choiceMulti": "Multiple",
        "choiceSingle": "Single",
        "min": "Min",
        "max": "Max",
        "applyAll": "Apply to all add-ons",
        "applyAllHint": "One shared config is applied to every linked accessory on save. Turn off to configure each independently.",
        "maxAddons": "Max add-ons / order",
        "unlimited": "Unlimited",
        "remove": "Remove"
      },
      "vendorModal": {
        "title": "Add vendor mapping",
        "description": "Pick a vendor + variant from this blueprint to wire the mapping.",
        "vendor": "Vendor",
        "searchVendors": "Search vendors by name…",
        "variant": "Variant",
        "pickVariant": "— Pick a variant —",
        "adding": "Adding…",
        "add": "Add"
      },
      "statusModal": {
        "aria": "Confirm status change",
        "title": "Confirm status change",
        "description": "Change blueprint status from {{from}} to {{to}}?",
        "confirm": "Confirm"
      },
      "templatePicker": {
        "inactiveBadge": "Inactive"
      },
      "vendorPicker": {
        "aria": "Assign vendor/location to SKU",
        "skuFallback": "SKU",
        "titleScoped": "Vendor — {{label}} · {{sku}}",
        "titleBulk": "Vendor / Location — {{count}} SKU(s)",
        "titleSingle": "Vendor / Location — {{sku}}",
        "descScoped": "Pick vendor + % for this location (location = the active tab). Total % = 100 to split orders; leave empty = routing picks the top-scoring vendor. Saved with the Save Change button.",
        "descGeneral": "Assign location + vendor to the SKU. The order % column splits per location: each location's total = 100 to split orders proportionally; leave empty = routing picks the top-scoring vendor. Saved with the Save Change button.",
        "emptyLocations": "No location yet. Click + Add Location to start.",
        "default": "Default",
        "vendor": "Vendor",
        "orderPct": "% of orders",
        "noVendorHint": "No vendor yet. Click \"+ Add Vendor\".",
        "selectLocationFirst": "Select a location first",
        "sumNoSplitTitle": "No split — routing picks the top-scoring vendor",
        "sumValidTitle": "Valid — split by %",
        "sumInvalidTitle": "This location's total % must = 100 (or leave all empty)",
        "needHundredSuffix": " — must = 100",
        "warnTitle": "Each location must total % = 100, or leave all empty (no split). Cannot Apply while a location is incomplete.",
        "warnText": "{{count}} location(s) below 100% — cannot save",
        "okTitle": "All locations have a valid % (=100)",
        "okText": "% valid — split by location",
        "apply": "Apply",
        "applyBulk": "Apply ({{count}})",
        "applyInvalidTitle": "A location's % is invalid (≠100 and ≠0) — set it to 100 or clear all %"
      },
      "bulkPrice": {
        "aria": "Bulk edit prices",
        "title": "Bulk Edit Prices — {{count}} SKU(s)",
        "description": "Enter the price (USD) for the tier to change. One tier at a time — pressing Apply will ask for a reason.",
        "pricePlaceholder": "USD (e.g. 19.99)",
        "apply": "Apply",
        "tierOrderHint": "Must be below the tier above it."
      },
      "logistic": {
        "exportHint": "Download logistics (.xlsx): SKU, weight, dimensions with units and per-service shipping fees ($).",
        "importHint": "Import an .xlsx/.csv to bulk-update weight, dimensions (with units) and shipping fees, matched by SKU."
      }
    },
    "list": {
      "heading": "Blueprints",
      "subtitle": "Manage your blueprint configurations and publishing workflows.",
      "loading": "Loading blueprints…",
      "empty": "No blueprints found",
      "rowActionsAria": "Row actions",
      "vendorCountOne": "{{count}} vendor",
      "vendorCountOther": "{{count}} vendors",
      "vendorModalAria": "Vendors for blueprint",
      "vendorModalTitle": "Vendors — {{name}}",
      "vendorModalDescOne": "{{count}} vendor supplies this blueprint.",
      "vendorModalDescOther": "{{count}} vendors supply this blueprint.",
      "vendorModalNote": "The detailed vendor list lives on the blueprint detail page. This summary modal only shows the aggregate vendor count.",
      "statusToggleAria": "Toggle status for {{name}}",
      "statusToggleOk": "Status updated",
      "statusToggleFailed": "Could not change the status",
      "activateTitle": "Put this product on sale?",
      "deactivateTitle": "Take this product off sale?",
      "activateDesc": "“{{name}}” becomes Active and appears in every merchant catalog. Publishing requires weight and dimensions on every SKU.",
      "deactivateDesc": "“{{name}}” becomes Inactive and disappears from every merchant catalog immediately. Orders already placed are unaffected.",
      "activateConfirm": "Put on sale",
      "deactivateConfirm": "Take off sale",
      "cancel": "Cancel",
      "onSale": "On sale",
      "offSale": "Off sale",
      "awaitingApproval": "Awaiting approval →",
      "close": "Close",
      "exportStarted": "Export started",
      "exportStartedDesc": "Download should begin shortly.",
      "stats": {
        "totalBlueprints": "Total Blueprints",
        "published": "Published",
        "draft": "Draft",
        "totalSkus": "Total SKUs",
        "categories": "Categories",
        "printAreas": "Print Areas"
      },
      "searchPlaceholder": "Search blueprints...",
      "searchAria": "Search blueprints",
      "filterPublishStatusAll": "Publish Status",
      "filterPublishStatusAria": "Filter by publish status",
      "filterCreatorAll": "Creator",
      "filterCreatorAria": "Filter by creator",
      "filterStatusAll": "Status",
      "filterStatusAria": "Filter by status",
      "filterClearHint": "Click again to clear this filter",
      "statusActive": "Active",
      "statusInactive": "Inactive",
      "statusDraft": "Draft",
      "statusPendingApproval": "Pending Approval",
      "colBlueprint": "Blueprint",
      "colProcessingTime": "Processing Time",
      "colPublishStatus": "Publish Status",
      "colPublishTime": "Publish Time",
      "colStatus": "Status",
      "colCreator": "Creator",
      "colCreatedDate": "Created Date",
      "colLastUpdate": "Last Update",
      "colUpdatedBy": "Updated By",
      "colAction": "Action",
      "selectAllAria": "Select all blueprints on this page",
      "selectRowAria": "Select {{name}}",
      "editAria": "Edit {{name}}",
      "configureSeoAria": "Configure SEO for {{name}}",
      "actionEdit": "Edit",
      "actionConfigureSeo": "Configure SEO",
      "bulkSelectedOne": "{{count}} SKU selected",
      "bulkSelectedOther": "{{count}} SKUs selected",
      "bulkClearAria": "Clear selection",
      "rowsPerPage": "Rows per page:",
      "showingRange": "Showing {{from}}–{{to}} of {{total}} blueprints",
      "prevPage": "Previous page",
      "nextPage": "Next page",
      "paginationAria": "Blueprint pagination",
      "loadError": "Could not load blueprints.",
      "retry": "Retry",
      "working": "Working…",
      "statusUpdated": "Status updated",
      "statusUpdatedDesc": "{{name}} is now {{status}}.",
      "statusUpdateFailed": "Could not update status",
      "duplicated": "Blueprint duplicated",
      "duplicatedDesc": "Created {{code}} as a draft copy.",
      "duplicatedManyDesc": "Created {{count}} draft copies.",
      "duplicateFailed": "Could not duplicate",
      "publishStatus": {
        "Published": "Published",
        "Draft": "Draft",
        "Unpublished": "Unpublished",
        "Pending": "Pending"
      },
      "seoModal": {
        "heading": "SEO Settings",
        "subtitle": "Optimize how “{{name}}” appears in search engines.",
        "loading": "Loading SEO settings…",
        "loadFailed": "Could not load this blueprint's SEO settings.",
        "titleLabel": "SEO Title",
        "titlePlaceholder": "Enter SEO title",
        "titleHelper": "If left empty, the system may automatically use the Alias.",
        "canonicalLabel": "Canonical URL",
        "canonicalPlaceholder": "https://example.com/blueprint/...",
        "canonicalHelper": "Preferred URL used by search engines to prevent duplicate content.",
        "googleIndexLabel": "Google Index",
        "keywordsLabel": "Meta Keywords",
        "keywordsPlaceholder": "Enter keyword and press Enter",
        "keywordRemove": "Remove keyword {{keyword}}",
        "descriptionLabel": "Meta Description",
        "descriptionPlaceholder": "Enter short summary for search engines...",
        "descriptionHelper": "Recommended length: 150–160 characters.",
        "descriptionCounter": "{{count}} / {{max}} characters",
        "cancel": "Cancel",
        "save": "Save",
        "saved": "SEO settings saved",
        "saveFailed": "Could not save SEO settings",
        "reApprovalHint": "This blueprint is Active. Saving SEO changes sends it back for approval, so merchants cannot order it until a checker approves it again.",
        "reApprovalTitle": "Saved — product taken off sale",
        "reApprovalDesc": "This edit sent the product back for approval, so merchants cannot order it until a checker approves it. Changed: {{fields}}.",
        "reApprovalResubmitTitle": "Saved — resubmitted for approval",
        "reApprovalResubmitDesc": "The product was previously rejected; this edit puts it back in the approval queue. Changed: {{fields}}.",
        "errors": {
          "titleTooLong": "The SEO Title must be at most {{max}} characters.",
          "canonicalInvalid": "The Canonical URL must start with http:// or https://.",
          "metaDescriptionTooLong": "The Meta Description must be at most {{max}} characters."
        }
      }
    },
    "blankMethods": {
      "heading": "Blank Methods",
      "banner": "Blank product — no print, engrave or embroidery fee. A default \"Blank Product\" record is seeded automatically.",
      "toast": {
        "created": "Blank method created",
        "createFailed": "Create failed",
        "createFailedTitle": "Create blank method failed",
        "deleted": "Blank method deleted"
      },
      "codeAria": "Code (slug)",
      "codePlaceholder": "code (e.g. blank-product)",
      "nameEnglish": "Display name (English)",
      "addBtn": "Add blank technique",
      "colCode": "Code",
      "empty": "No blank methods yet — add one above.",
      "toggleTitleOn": "Active — click to deactivate",
      "toggleTitleOff": "Inactive — click to activate",
      "toggleAria": "Active toggle for {{code}}",
      "confirmDelete": "Delete blank method \"{{code}}\"?"
    },
    "listFilters": {
      "search": {
        "placeholder": "Search blueprints, SKU or category…",
        "aria": "Search blueprints"
      },
      "status": {
        "aria": "Filter by status",
        "all": "All Status",
        "pendingApproval": "Pending Approval"
      },
      "source": {
        "aria": "Filter by source",
        "all": "All Sources",
        "admin": "Admin"
      },
      "clear": "Clear"
    },
    "imagesSection": {
      "headerCountOne": "{{count}} image · minimum 5 required",
      "headerCountOther": "{{count}} images · minimum 5 required",
      "tooFew": "Need at least 5 mockup images before this blueprint can be saved.",
      "bulkMax": "Already at the 10-image maximum.",
      "bulkFailed": "{{count}} failed",
      "bulkSkipped": "{{count}} skipped (max 10)",
      "dragTitle": "Drag to reorder image",
      "moveEarlier": "Move image {{index}} earlier",
      "moveLater": "Move image {{index}} later",
      "removeImage": "Remove image {{index}}",
      "max10": "Max 10 images",
      "uploadOne": "+ Upload image",
      "uploadMultiple": "+ Upload multiple",
      "pickerTitle": "Upload mockup image"
    },
    "personalize": {
      "heading": "3. Personalize",
      "toggleOn": "Personalize: ON",
      "toggleOff": "Personalize: OFF",
      "intro": "Select which of the 19 fixed personalization zones are available for this blueprint.",
      "zonesAria": "Personalization zones",
      "zonesEnabled": "{{active}}/{{total}} zones enabled",
      "disabled": "Personalization disabled — zone grid hidden.",
      "zones": {
        "front-center": "Front Center",
        "front-left-chest": "Front Left Chest",
        "front-right-chest": "Front Right Chest",
        "front-bottom": "Front Bottom",
        "back-center": "Back Center",
        "back-upper": "Back Upper",
        "back-bottom": "Back Bottom",
        "left-sleeve": "Left Sleeve",
        "right-sleeve": "Right Sleeve",
        "collar": "Collar",
        "hood-front": "Hood Front",
        "hood-back": "Hood Back",
        "pocket-front": "Pocket Front",
        "pocket-back": "Pocket Back",
        "cuff-left": "Cuff Left",
        "cuff-right": "Cuff Right",
        "hem": "Hem",
        "side-left": "Side Left",
        "side-right": "Side Right"
      }
    },
    "pricingSection": {
      "heading": "4. Pricing",
      "headerSummary": "{{variants}} variant(s) · {{tiers}} tier(s) · {{selected}} selected",
      "bulkApplyNone": "Bulk apply price to no selected variants:",
      "bulkApplyOne": "Bulk apply price to {{count}} selected variant:",
      "bulkApplyOther": "Bulk apply price to {{count}} selected variants:",
      "tierLabel": "Tier",
      "priceUsd": "Price (USD)",
      "applyTierPrice": "Apply tier price…",
      "auditReason": "Audit reason required",
      "invalidPrice": "Enter a non-negative USD price (e.g. 19.99)",
      "colVariant": "Variant (SKU)",
      "selectAllAria": "Select all variants",
      "selectRowAria": "Select variant {{sku}}",
      "empty": "No variants — add some from the Variants section first."
    },
    "importDialog": {
      "title": "Import blueprints",
      "description": "Upload a multi-sheet XLSX file. The server will parse it, surface duplicates, and then commit the records.",
      "steps": {
        "upload": "1. Upload",
        "preview": "2. Preview",
        "confirm": "3. Confirm"
      },
      "upload": {
        "intro": "Upload an XLSX file with the standard multi-sheet template (Metadata + Pricing). The server will parse it and surface any duplicate-detection warnings before commit.",
        "downloadTemplate": "Download template",
        "selected": "Selected:",
        "fileKb": "{{size}} KB"
      },
      "preview": {
        "noData": "No preview data.",
        "sheets": "Sheets",
        "noSheets": "(no sheets detected)",
        "rows": "{{count}} rows",
        "duplicateDetection": "Duplicate detection",
        "noDuplicates": "No similar blueprints detected.",
        "rowLabel": "Row {{row}} —",
        "score": "(score {{score}})"
      },
      "confirm": {
        "body": "Confirm import of the file shown below. Press \"Confirm\" to proceed."
      },
      "done": "Import preview accepted. The actual commit endpoint will land in a follow-up wave; this dialog can now be closed.",
      "footer": {
        "uploadPreview": "Upload & preview",
        "confirming": "Confirming…",
        "confirm": "Confirm"
      },
      "toast": {
        "noFileTitle": "No file selected",
        "noFileDesc": "Please pick an XLSX file before continuing.",
        "previewFailed": "Import preview failed",
        "unexpected": "Server returned an unexpected response.",
        "previewedTitle": "Import previewed",
        "previewedDesc": "Preview accepted. Commit handler will land in a follow-up wave."
      }
    },
    "routing": {
      "modeMerchant": "Merchant",
      "modePercent": "%",
      "modeGroupAria": "Order split mode for {{vendor}}",
      "defaultVendorAria": "Default vendor {{vendor}}",
      "merchantPlaceholder": "Select merchants",
      "merchantSearch": "Search merchant",
      "merchantSearching": "Searching merchants…",
      "merchantEmpty": "No merchant found",
      "errorMerchantEmpty": "Select at least one merchant",
      "errorMerchantDup": "{{merchant}} is already assigned to another vendor in this location",
      "merchantLoadError": "Cannot load merchants (missing permission user:read)",
      "toastMerchantInvalid": "Some vendors in Merchant mode have no merchant or share one with another vendor."
    },
    "accessoryParents": {
      "title": "Blueprints using this accessory",
      "searchPlaceholder": "Search by name or code",
      "colImage": "Image",
      "colName": "Name",
      "colCode": "Code",
      "colCategory": "Category",
      "colStatus": "Status",
      "empty": "No blueprint links this accessory",
      "loadFailed": "Could not load linked blueprints",
      "openInNewTab": "Open {{name}} in a new tab",
      "close": "Close",
      "rowsPerPage": "Rows per page",
      "range": "Showing {{from}}–{{to}} of {{total}}",
      "prevPage": "Previous page",
      "nextPage": "Next page",
      "paginationAria": "Linked blueprints pagination"
    },
    "accessoryOff": {
      "title": "Turn Off Accessories?",
      "body1": "Turning off Accessories will convert this Blueprint into a regular Blueprint and remove it from the accessory lists of these Blueprints.",
      "body2": "Are you sure you want to continue?",
      "viewProducts": "View Products",
      "cancel": "Cancel",
      "save": "Save",
      "close": "Close"
    },
    "retail": {
      "label": "Retail",
      "hint": "Show this accessory on the Homepage and sell it on its own",
      "disabledHint": "Turn on Accessories to enable Retail"
    }
  },
  "product_approval": {
    "title": "Product Approval",
    "subtitle": "Vendor product submissions pending review",
    "columns": {
      "product": "Product",
      "vendor": "Vendor",
      "submittedAt": "Submitted",
      "category": "Category",
      "status": "Status",
      "type": "Type",
      "actions": "Actions"
    },
    "status": {
      "pending": "Pending Review",
      "approved": "Approved",
      "rejected": "Rejected",
      "changesRequested": "Changes Requested"
    },
    "actions": {
      "approve": "Approve",
      "reject": "Reject",
      "requestChanges": "Request Changes",
      "viewDiff": "View Diff",
      "uploadExcel": "Upload Excel",
      "diff": "Diff",
      "details": "Details",
      "cancel": "Cancel"
    },
    "fields": {
      "rejectionReason": "Rejection Reason",
      "changeNotes": "Change Request Notes"
    },
    "pageSubtitle": "Review new products and vendor changes. Re-approval applies to 5 fields: {{fields}}.",
    "types": {
      "newSubmission": "New Submission",
      "reApproval": "Re-approval",
      "adminSelfCreate": "Admin Self-Create"
    },
    "filters": {
      "typeLabel": "Type",
      "statusLabel": "Status",
      "sourceLabel": "Source",
      "allTypes": "All types",
      "allStatuses": "All statuses"
    },
    "source": {
      "all": "All sources",
      "vendorSelfSubmit": "Vendor self-submit",
      "adminExcelUpload": "Admin Excel upload"
    },
    "sourcePill": {
      "vendorSubmit": "Vendor submit",
      "adminUpload": "Admin upload"
    },
    "summary": {
      "pendingLabel": "pending",
      "totalLabel": "total"
    },
    "bulk": {
      "selected": "{{count}} selected",
      "approve": "Approve ({{count}})",
      "approving": "Approving…",
      "reject": "Reject ({{count}})",
      "clear": "Clear selection"
    },
    "table": {
      "selectAllAria": "Select all pending",
      "selectRowAria": "Select {{name}}",
      "loading": "Loading…",
      "empty": "No products in the queue."
    },
    "links": {
      "viewVendorProduct": "View VendorProduct",
      "openBlueprint": "Open blueprint detail"
    },
    "applyTargets": "Will apply to {{count}} vendors on approval",
    "duplicate": {
      "title": "Found {{count}} similar blueprints",
      "similarity": "(similarity {{pct}}%)"
    },
    "reject": {
      "title": "Reject — {{name}}",
      "bulkTitle": "Reject {{count}} products",
      "hint": "Rejection reason (10-500 characters). Will be logged to the audit trail and sent to the vendor.",
      "placeholder": "E.g. baseCost does not match the market, please double-check and add shipping zone EU…",
      "counter": "{{count}} / 500 (minimum 10)",
      "submitting": "Sending…",
      "confirm": "Confirm Reject",
      "errorLength": "Reason must be 10-500 characters long"
    },
    "override": {
      "title": "4-eyes override — {{name}}",
      "bodyBefore": "You are approving a blueprint you created yourself. The ",
      "bodyAfter": " role allows bypassing the 4-eyes rule, but you must state a clear reason for the audit log.",
      "reasonLabel": "Override reason",
      "placeholder": "Example: only 1 superadmin on duty today, already cross-reviewed with QA…",
      "hint": "1-2000 characters. The reason will be recorded in the audit log.",
      "submitting": "Sending…",
      "confirm": "Confirm override",
      "errorLength": "Override reason must be 1-2000 characters long"
    },
    "diff": {
      "loading": "Loading diff…"
    },
    "errors": {
      "generic": "An error occurred",
      "fourEyesRequired": "You cannot approve a blueprint you created yourself. A different admin must approve it.",
      "overrideReasonRequired": "A superadmin approving their own blueprint must provide an override reason.",
      "notReadyForPublish": "This blueprint is not ready to publish — add the missing mockups and print areas on the detail page before approving.",
      "blueprintNotFound": "The blueprint referenced by this approval no longer exists.",
      "approvalNotFound": "This approval request was not found.",
      "alreadyResolved": "This submission has already been resolved.",
      "categoryNotFound": "No category is available to anchor the new blueprint. Seed at least one category before approving.",
      "costGuard": "Vendor cost is not below the lowest merchant price for some SKUs — see the SKU list, then reject with a reason.",
      "alreadyListed": "This vendor is already linked to one of these Printway SKUs through another product.",
      "blueprintUnavailable": "The Printway product is not Active (or a SKU no longer belongs to it).",
      "pricingMissing": "A Printway SKU has no merchant price yet — set pricing on the blueprint first.",
      "variantSpecOutOfRange": "A variant's processing time (1–60 days), capacity (≥ 1/day), weight or dimensions (> 0) is out of range — ask the vendor to fix it.",
      "withSkus": "{{reason}} — {{skus}}",
      "forProduct": "{{product}}: {{reason}}",
      "conflictRetry": "Another change touched this submission at the same time. Nothing was saved — please try again."
    },
    "toast": {
      "loadFailTitle": "Could not load the list",
      "unknownError": "Unknown error",
      "approveFailed": "Approve failed",
      "approved": "Product approved",
      "rejected": "Product rejected",
      "approvedCount": "Approved {{ok}}/{{total}}",
      "rejectedCount": "Rejected {{ok}}/{{total}}",
      "failCount": "{{fail}} failed."
    },
    "diffModal": {
      "title": "Re-approval diff",
      "empty": "The vendor did not change any field that requires re-approval (only changed description / images / tags). Re-approval is not needed.",
      "col": {
        "field": "Field",
        "previous": "Previous",
        "new": "New"
      },
      "fields": {
        "processingTime": "Processing time",
        "baseCost": "Base cost",
        "capacityPerDay": "Capacity / day",
        "shippingZones": "Shipping zones",
        "productionSpecs": "Production specs",
        "cost_price_cents": "Base cost",
        "variant_dimensions": "Dimensions",
        "variant_processing_time_days": "Processing time (days)",
        "variant_capacity_per_day": "Capacity / day",
        "variant_weight_grams": "Weight (g)",
        "variant_cost_cents": "Cost (per SKU)",
        "variant_cost_markup_cents": "Markup"
      },
      "actions": {
        "close": "Close"
      }
    },
    "uploadDialog": {
      "title": {
        "upload": "Upload vendor product Excel",
        "preview": "Preview — products pending review"
      },
      "fileLabel": "CSV/Excel file",
      "selectVendorPlaceholder": "— Select vendor —",
      "vendorLoadFail": "Could not load the vendor list. Reopen this dialog after visiting the Vendors page so the cache is populated.",
      "parsedRows": "Parsed {{count}} rows — check the preview after upload.",
      "applyLabel": "Apply blueprint to vendors (optional)",
      "applyHelp": "When the admin approves, the system seeds 1 VendorProduct (state=\"live\") for each selected vendor. Leave empty = blueprint goes to the shared catalog only.",
      "applyVendorEmpty": "The vendor directory has no data yet — the apply-to picker is unavailable.",
      "applyCountNote": "Will apply to {{count}} vendors when the admin approves.",
      "previewSummary": "{{products}} products, {{variants}} variants. Upload ID:",
      "validationErrorsTitle": "Validation errors ({{count}})",
      "errorRow": "Row {{row}}",
      "col": {
        "diffWarning": "Diff / warning"
      },
      "badgeNew": "New",
      "fieldsChanged": "{{count}} fields changed",
      "similarBlueprints": "{{count}} similar blueprints",
      "uploading": "Uploading…",
      "uploadPreview": "Upload + preview",
      "actions": {
        "close": "Close"
      },
      "parse": {
        "noRows": "No data rows found — check the header.",
        "readFail": "Could not read the file: {{message}}",
        "readFailGeneric": "Could not read the Excel/CSV file"
      },
      "toast": {
        "uploadFailedTitle": "Upload failed",
        "uploadedTitle": "Uploaded and parsed",
        "uploadedDesc": "{{products}} products / {{variants}} variants pending review."
      }
    },
    "mapping": {
      "linksTo": "Approving links this vendor to the Printway product",
      "col": {
        "sku": "Printway SKU",
        "vendorLabel": "Vendor size / color",
        "printwayLabel": "Printway size / color",
        "cost": "Vendor cost",
        "lowestTier": "Lowest merchant price",
        "margin": "Margin"
      },
      "disabled": "off",
      "labelMismatch": "label differs from Printway",
      "noPrice": "No price",
      "violationHint": "Rows in red: vendor cost is not below the lowest merchant price — approval will be refused."
    },
    "confirmApprove": {
      "title": "Approve this submission?",
      "bulkTitle_one": "Approve {{count}} submission?",
      "bulkTitle_other": "Approve {{count}} submissions?",
      "body_one": "Approving links the vendor to the Printway product for {{count}} SKU.",
      "body_other": "Approving links the vendor to the Printway product for {{count}} SKUs.",
      "bulkBody_one": "Approve {{count}} submission. Mapped products link their vendor to the Printway product.",
      "bulkBody_other": "Approve {{count}} submissions. Mapped products link their vendor to the Printway product.",
      "routing": "Linked SKUs enter order routing: where a SKU has no allocation, this vendor can receive orders right away by score.",
      "bodyGeneric": "Mapped vendor products link their vendor to the Printway product when approved.",
      "bulkBodySkus_one": "Approve {{count}} submission — {{skus}} SKUs enter the routing pool.",
      "bulkBodySkus_other": "Approve {{count}} submissions — {{skus}} SKUs enter the routing pool.",
      "loading": "Counting the SKUs to link…",
      "loadFailed": "Could not load the SKU mapping"
    },
    "unmappedBadge": "Not mapped"
  },
  "products_special": {
    "title": "Special Products",
    "subtitle": "Featured / special product assignments",
    "columns": {
      "product": "Product",
      "tag": "Tag",
      "assignedAt": "Assigned",
      "expiresAt": "Expires",
      "blueprintCode": "Blueprint code",
      "name": "Name",
      "variantAssignments": "Variant assignments",
      "merchants": "Merchants",
      "createdDate": "Created date",
      "actions": "Actions",
      "productName": "PRODUCT NAME",
      "skuCount": "SKU COUNT",
      "assignedMerchants": "ASSIGNED MERCHANTS",
      "status": "STATUS",
      "action": "ACTION"
    },
    "actions": {
      "assign": "Assign Special",
      "unassign": "Unassign",
      "edit": "Edit",
      "delete": "Delete"
    },
    "fields": {
      "tag": "Special Tag",
      "expiresAt": "Expires At"
    },
    "list": {
      "heading": "Product Special",
      "subtitle": "Manage special products that are exclusively available for selected merchants.",
      "create": "Create",
      "searchLabel": "Search",
      "searchPlaceholder": "Search by product name or SKU...",
      "merchantMin": "Min merchants",
      "merchantMax": "Max merchants",
      "createdAfter": "Created from",
      "createdBefore": "Created to",
      "clearFilter": "Clear filters",
      "totalCount": "{{count}} blueprint special",
      "selectedLabel": "blueprint special selected",
      "deselect": "Deselect",
      "deleting": "Deleting…",
      "deleteSelected": "Delete {{count}} rows",
      "loading": "Loading Products Special…",
      "loadError": "Could not load the list: {{message}}",
      "empty": "No product specials yet.",
      "selectAllAria": "Select all rows on this page",
      "selectRowAria": "Select {{code}}",
      "variantCount": "{{count}} variant",
      "allBlueprint": "Entire blueprint",
      "assignMerchantsOne": "{{count}} merchant →",
      "assignMerchantsOther": "{{count}} merchants →",
      "rowsLabel": "Rows",
      "rowsPerPageAria": "Rows per page",
      "bulkDeleted": "Bulk deleted",
      "bulkDeletedPartial": "{{deleted}} deleted, {{notFound}} not found",
      "bulkDeletedAll": "Deleted {{count}} blueprint special",
      "deleteFailed": "Delete failed",
      "networkError": "Network error",
      "confirmBulkDelete": "Delete {{count}} selected blueprint special?",
      "deleted": "Product special removed",
      "confirmDelete": "Remove \"{{label}}\" from product specials? The blueprint returns to the public catalog.",
      "noVariantAssignment": "No variant assignment yet",
      "searchAria": "Search product specials",
      "filterStatusAll": "Status: All",
      "filterStatusAria": "Filter by status",
      "working": "Working…",
      "retry": "Retry",
      "rowsPerPage": "Rows per page:",
      "showingRange": "Showing {{from}}-{{to}} of {{total}} product specials",
      "paginationAria": "Product special pagination",
      "prevPage": "Previous page",
      "nextPage": "Next page",
      "skuCount": "{{count}} SKUs",
      "noMerchants": "No merchants",
      "moreMerchants": "+{{count}} more",
      "statusToggleAria": "Toggle status for {{name}}",
      "editAria": "Edit merchant assignment for {{name}}",
      "deleteAria": "Remove {{name}} from product specials",
      "statusActivated": "Product special activated",
      "statusDeactivated": "Product special deactivated",
      "statusFailed": "Could not change the status",
      "confirmDeleteTitle": "Remove from product specials?"
    },
    "detail": {
      "missingId": "Missing ID",
      "loading": "Loading…",
      "loadError": "Failed to load details: {{message}}",
      "noData": "no data",
      "emptyResponse": "Empty response",
      "unknownError": "Unknown error",
      "backToList": "← Back to list",
      "blueprintMissing": "— blueprint missing —",
      "codeLabel": "Code:",
      "assignmentIdLabel": "Assignment ID:",
      "merchantsAssigned": "{{count}} merchants assigned",
      "createdAt": "Created: {{date}}",
      "updatedAt": "Updated: {{date}}",
      "blueprintCard": "Blueprint",
      "noTags": "No tags",
      "blueprintDeleted": "Blueprint deleted or does not exist.",
      "blueprintLevelTitle": "Blueprint-level merchant assignments",
      "noBlueprintAssignments": "No merchants assigned at blueprint level.",
      "variantLevelTitle": "Variant-level merchant assignments",
      "variantCol": "Variant",
      "statusCol": "Status",
      "auditLogTitle": "Audit log ({{count}})",
      "noAuditEntries": "No audit entries yet.",
      "actorLabel": "Actor: {{actor}}",
      "viewGroupAria": "Variant assignment view mode",
      "viewByVariant": "By variant",
      "viewByMerchant": "By merchant",
      "noVariantMerchantAssignments": "No variant-level merchant assignments yet.",
      "variantsForMerchant": "{{count}} variants",
      "auditAction": {
        "create": "Added to Products Special",
        "update_assignments": "Merchant assignments changed",
        "remove_blueprint": "Removed from Products Special"
      },
      "assignMerchants": "Assign merchants",
      "assignPerVariant": "Assign per SKU"
    },
    "attributesGenerator": {
      "labelPlaceholder": "-- Label --",
      "addAttribute": "+ Add Option",
      "skuGeneratedOne": "{{count}} SKU generated — table on the right updates as you tick values.",
      "skuGeneratedOther": "{{count}} SKUs generated — table on the right updates as you tick values.",
      "clearOption": "Clear option",
      "searchOption": "Search option…",
      "removeAttribute": "Remove option",
      "loadingOptions": "Loading options…",
      "noOptionsForLabel": "No options found for {{label}}",
      "noOptionsMatch": "No options match",
      "selectValues": "Select values…",
      "noActiveValues": "No active values for this option.",
      "noValuesMatch": "No values match.",
      "maxReached": "Maximum {{max}} options per blueprint reached.",
      "columnOptionType": "Option Type",
      "columnOptionName": "Option Name",
      "columnOptionValues": "Option Values",
      "pickOptionFirst": "Pick an Option Name first",
      "searchValues": "Search values…",
      "removeValueAria": "Remove {{value}}",
      "valueLockedInUse": "In use by existing SKUs — can be added to, not removed"
    },
    "giftMessagesTab": {
      "sectionAria": "Gift Messages",
      "newTitle": "New gift message template",
      "namePlaceholder": "Template name (EN)",
      "maxLengthPlaceholder": "Max length",
      "pricePlaceholder": "Price (cents)",
      "saving": "Saving…",
      "submit": "Create template",
      "empty": "No templates yet — create one above.",
      "errTierRequired": "A tier and a non-negative integer price are required.",
      "toastCreated": "Gift message template created",
      "toastCreateFailed": "Create gift template failed",
      "col": {
        "nameEn": "Name (EN)",
        "maxLength": "Max length",
        "tierRows": "Tier rows",
        "firstTierPrice": "First-tier price"
      }
    },
    "assignModal": {
      "saveSuccess": "Assignment saved",
      "saveErrorTitle": "Could not save assignment",
      "networkCheckError": "Network error — check connection",
      "title": "Assign merchants — {{name}}",
      "hint": "Variant-level grid. Checkboxes for hidden variants are disabled.",
      "scopeGroupAria": "Merchant list scope",
      "scopeAssigned": "Assigned ({{count}})",
      "scopeAll": "All ({{count}})",
      "noAssignedYet": "No merchants assigned yet. Switch to \"All\" to add one.",
      "noMerchants": "No merchants in the directory.",
      "merchantCol": "Merchant",
      "allVariantsTitle": "Toggle assignment for the ENTIRE blueprint (all variants)",
      "allVariants": "All variants",
      "hiddenVariantTitle": "Hidden variant — disabled",
      "hiddenCheckboxTitle": "Cannot assign a hidden variant",
      "cancel": "Cancel",
      "saving": "Saving…",
      "save": "Save assignment",
      "scopeAllShort": "All merchants",
      "searchPlaceholder": "Search merchant by name or email…",
      "loadingMerchants": "Loading merchants…",
      "directoryError": "Could not load the merchant directory. Check your connection and try again.",
      "noSearchMatch": "No merchant matches “{{term}}”.",
      "offscreenNote": "All {{count}} assigned merchants are saved, including any not shown on this page.",
      "removeCol": "Remove merchant",
      "removeMerchantTitle": "Remove {{name}} from this product",
      "removeConfirmTitle": "Remove this merchant?",
      "removeConfirmDesc": "{{name}} will no longer be able to order this product, and their per-SKU selections are discarded. Takes effect when you save.",
      "removeConfirmCta": "Remove merchant",
      "emptyRowTitle": "Every merchant needs at least one SKU",
      "emptyRowDesc": "{{count}} merchant row(s) have nothing ticked. Tick at least one SKU, or use the remove button to un-assign the merchant.",
      "emptyRowHint": "Tick at least one SKU, or remove this merchant."
    },
    "createModal": {
      "createSuccess": "Products Special created",
      "createErrorTitle": "Could not create",
      "title": "Create Products Special",
      "hint": "Pick a blueprint to hide from the shared catalog and assign it to specific merchants. Variant-level assignment can be refined after creation, via the \"N merchants →\" button.",
      "blueprintLabel": "Blueprint",
      "blueprintSearchPlaceholder": "Search blueprints by name / code…",
      "merchantsLabel": "Merchants",
      "merchantSearchPlaceholder": "Search merchants by name / email…",
      "cancel": "Cancel",
      "submitDisabledTitle": "Pick 1 blueprint and enter ≥ 1 merchant ID",
      "creating": "Creating…",
      "submit": "Create"
    },
    "status": {
      "Active": "Active",
      "Inactive": "Inactive"
    },
    "createSheet": {
      "title": "Create Product Special",
      "blueprintLabel": "Blueprint",
      "blueprintSearchPlaceholder": "Select blueprint",
      "assignmentHeading": "SKU & Merchant Assignment",
      "modeAll": "Apply to all SKUs",
      "modePerSku": "Configure per SKU",
      "merchantLabel": "Merchant",
      "merchantSearchPlaceholder": "Select merchants",
      "colSkuCode": "SKU CODE",
      "colSkuName": "SKU NAME",
      "colAssignedMerchants": "ASSIGNED MERCHANTS",
      "hiddenSku": "Hidden — cannot be assigned",
      "noSkus": "This blueprint has no SKUs yet.",
      "pickBlueprintFirst": "Pick a blueprint to list its SKUs.",
      "skusLoadError": "Could not load the SKUs.",
      "showingSkus": "Showing {{from}}-{{to}} of {{total}} SKUs",
      "skuPaginationAria": "SKU pagination",
      "duplicateBlueprint": "This blueprint is already a product special.",
      "createSuccess": "Product special created",
      "createErrorTitle": "Could not create the product special",
      "cancel": "Cancel",
      "save": "Save",
      "editTitle": "Edit Product Special",
      "updateSuccess": "Product special updated",
      "updateErrorTitle": "Could not save the changes"
    }
  },
  "bundle": {
    "title": "Bundles",
    "subtitle": "Multi-product bundles",
    "columns": {
      "name": "Name",
      "productCount": "Products",
      "price": "Price",
      "isActive": "Active",
      "code": "Code",
      "components": "Components",
      "status": "Status"
    },
    "actions": {
      "create": "Create Bundle",
      "edit": "Edit",
      "pause": "Pause",
      "resume": "Resume",
      "delete": "Delete"
    },
    "banners": {
      "paused": "This bundle is paused — not visible to merchants"
    },
    "fields": {
      "name": "Bundle Name",
      "products": "Products",
      "price": "Bundle Price (USD)",
      "description": "Description"
    },
    "list": {
      "heading": "Bundles",
      "subtitle": "Combine multiple blueprints into one sellable SKU — fixed price (USD).",
      "searchPlaceholder": "Search by code or name…",
      "totalCount": "{{count}} bundle",
      "loading": "Loading bundles…",
      "loadError": "Failed to load: {{message}}",
      "empty": "No bundles yet.",
      "componentCount": "{{count}} blueprint",
      "pageInfo": "Page {{page}} / {{total}}",
      "prev": "Prev",
      "next": "Next",
      "created": "Bundle {{code}} created"
    },
    "create": {
      "title": "New bundle",
      "note": "Fixed price (USD) only. No discount / sum / dynamic pricing.",
      "codeLabel": "Code (UPPERCASE)",
      "descLabel": "Description (optional)",
      "descPlaceholder": "Editorial copy",
      "priceLabel": "Price (USD) — fixed",
      "priceHint": "={{cents}} cents — single price only; no discount/sum/dynamic pricing.",
      "componentsLabel": "Component blueprints (2-20)",
      "componentsSearchPlaceholder": "Search blueprints by name or code…",
      "cancel": "Cancel",
      "creating": "Creating…",
      "submit": "Create bundle",
      "createFailed": "Failed to create bundle",
      "networkError": "Network error — check connection",
      "codePlaceholder": "MUG-COMBO-01",
      "namePlaceholder": "Mug + sticker combo",
      "hint": {
        "code": "Code must be UPPERCASE letters, numbers, _ or - (no spaces).",
        "name": "Enter a bundle name.",
        "price": "Price must be greater than 0.",
        "components": "Pick 2 to 20 component templates."
      }
    },
    "detail": {
      "close": "Close",
      "componentsTitle": "Components ({{count}})",
      "loadingComponents": "Loading components…",
      "noComponents": "No components."
    }
  },
  "mapping": {
    "title": "Mappings",
    "subtitle": "Product-to-vendor SKU mappings",
    "columns": {
      "product": "Product",
      "vendor": "Vendor",
      "vendorSku": "Vendor SKU",
      "updatedAt": "Updated",
      "externalSku": "External SKU",
      "sourceTitle": "Source title",
      "candidates": "Candidates",
      "ticket": "Ticket",
      "generated": "Generated"
    },
    "banners": {
      "ticketOnly": "Mappings are managed via support tickets only — contact admin to request changes"
    },
    "actions": {
      "viewHistory": "View History"
    },
    "page": {
      "title": "Mapping Errors",
      "subtitle": "SKU mappings that don't match between the external store and the internal blueprint.",
      "bannerTitle": "Resolve only with a support ticket.",
      "bannerBody1": "Admins may only handle mappings once the merchant has opened a ticket",
      "bannerBody2": "Resolving without a ticket will be rejected by the system.",
      "searchPlaceholder": "Search by external SKU…",
      "ticketOnlyLabel": "Only rows with a ticket",
      "pendingCount": "{{count}} pending",
      "loading": "Loading pending mappings…",
      "loadError": "Failed to load:",
      "unknownError": "unknown",
      "emptyBase": "No pending mappings",
      "emptyTicketSuffix": " (with ticket)",
      "candidateSummary": "{{count}} candidate (top {{pct}}%)",
      "openTicket": "Open ticket →",
      "noTicketTooltip": "Cannot resolve without a ticket",
      "noTicket": "No ticket",
      "pageInfo": "Page {{page}} / {{total}}",
      "prev": "Prev",
      "next": "Next"
    }
  },
  "collection": {
    "title": "Collections",
    "subtitle": "Curated product collections",
    "columns": {
      "name": "Name",
      "blueprintCount": "Blueprints",
      "isActive": "Active"
    },
    "actions": {
      "create": "Create Collection"
    },
    "fields": {
      "name": "Collection Name",
      "slug": "Slug",
      "blueprints": "Blueprints",
      "description": "Description",
      "seoTitle": "SEO Title",
      "seoDescription": "SEO Description",
      "image": "Cover Image"
    },
    "page": {
      "title": "Collections",
      "subtitle": "Group blueprints for catalog filtering and homepage display. Many-to-many, each collection has its own SEO.",
      "newCollection": "New collection",
      "searchPlaceholder": "Search by slug or name (EN)…",
      "countLabel": "{{count}} collections",
      "loading": "Loading collections…",
      "loadError": "Failed to load:",
      "empty": "No collections yet.",
      "columns": {
        "slug": "Slug",
        "nameEn": "Name (EN)",
        "blueprints": "Blueprints",
        "seoIndex": "SEO Index",
        "status": "Status",
        "sort": "Sort"
      },
      "blueprintCount": "{{count}} blueprints",
      "indexed": "Indexed",
      "noindex": "noindex",
      "pageOf": "Page {{page}} / {{total}}",
      "prev": "Prev",
      "next": "Next"
    },
    "statusLabels": {
      "Active": "Active",
      "Inactive": "Inactive"
    },
    "toasts": {
      "created": "Created collection \"{{slug}}\""
    },
    "modal": {
      "createError": "Could not create collection",
      "networkError": "Network error — check connection",
      "title": "New collection",
      "subtitle": "Many-to-many blueprints + SEO block (title/canonical/index/keywords/description).",
      "nameEn": "Name (EN)",
      "nameEnPlaceholder": "Summer Tees",
      "nameVi": "Name (VI, optional)",
      "nameViPlaceholder": "Summer Tees",
      "slug": "Slug (kebab-case)",
      "sortOrder": "Sort order",
      "descEn": "Description (EN, optional)",
      "descEnPlaceholder": "Editorial copy",
      "status": "Status",
      "blueprints": "Blueprints (many-to-many)",
      "blueprintsSearchPlaceholder": "Search blueprints by name or code…",
      "blueprintsHelper": "A blueprint can belong to multiple collections.",
      "seoBlock": "SEO block",
      "seoTitle": "Title",
      "seoCanonical": "Canonical URL",
      "seoAllowIndex": "Allow Google index",
      "seoKeywords": "Meta keywords (comma-separated)",
      "seoDescription": "Meta description",
      "seoDescriptionPlaceholder": "Curated summer tee blueprints…",
      "cancel": "Cancel",
      "submitting": "Creating…",
      "submit": "Create collection",
      "seoTitlePlaceholder": "Summer Tees | PrintWay",
      "seoCanonicalPlaceholder": "https://printway.com/collections/summer-tees",
      "seoKeywordsPlaceholder": "tee, summer, print"
    },
    "list": {
      "colLabel": "Label",
      "empty": "No collections match these filters.",
      "showingRange": "Showing {{from}}–{{to}} of {{total}} collections",
      "searchPlaceholder": "Search collections...",
      "searchAria": "Search collections"
    },
    "form": {
      "createTitle": "Create Collection",
      "editTitle": "Edit Collection",
      "saveCollection": "Save Collection",
      "labelLabel": "Label",
      "labelPlaceholder": "New",
      "hexLabel": "HEX Color",
      "hexPlaceholder": "#E53935",
      "errors": {
        "hexInvalid": "HEX Color must look like #RGB or #RRGGBB."
      }
    }
  },
  "add_on": {
    "title": "Add-ons",
    "subtitle": "Product add-ons configuration",
    "tabs": {
      "config": "Configuration",
      "accessories": "Accessories",
      "gift": "Gift Options"
    },
    "columns": {
      "name": "Name",
      "type": "Type",
      "price": "Price",
      "isActive": "Active"
    },
    "actions": {
      "create": "Create Add-on",
      "edit": "Edit",
      "delete": "Delete"
    },
    "fields": {
      "name": "Name",
      "type": "Type",
      "price": "Price (USD)",
      "description": "Description"
    },
    "page": {
      "subtitle": "Unified add-ons workspace: Configuration and Gift Options. Accessories are now managed as accessory blueprints in Products > Blueprints.",
      "tabsAria": "Add-ons sub-tabs"
    },
    "accessoriesTab": {
      "readonlyNote": "Accessories list (read-only). Full variant management ships in a later update.",
      "empty": "No accessory blueprints yet. Mark a blueprint as an accessory in the blueprint editor.",
      "yes": "Yes",
      "no": "No",
      "col": {
        "nameEn": "Name (EN)",
        "standalone": "Standalone",
        "variants": "Variants",
        "firstVariantPrice": "First-variant price",
        "name": "Name",
        "code": "Code",
        "locations": "Locations"
      },
      "note": "Blueprints marked as accessories. Link them as add-ons to a main product below.",
      "linkTitle": "Link accessory add-on",
      "mainLabel": "Main product",
      "mainPlaceholder": "Select a main blueprint",
      "accessoryLabel": "Accessory",
      "accessoryPlaceholder": "Select an accessory blueprint",
      "chargeFeeLabel": "Charge additional fee",
      "fromQtyLabel": "Charge from unit #",
      "linkBtn": "Link add-on",
      "toastLinked": "Accessory add-on linked",
      "toastLinkFailed": "Could not link accessory add-on",
      "errSelectBoth": "Select both a main product and an accessory.",
      "errAlreadyLinked": "This accessory is already linked to the selected product.",
      "status": {
        "Active": "Active",
        "Inactive": "Inactive",
        "Draft": "Draft",
        "PendingApproval": "Pending approval"
      }
    },
    "addonsTab": {
      "sectionAria": "Config Add-ons",
      "newTitle": "New add-on",
      "nameEnLabel": "Name (English)",
      "namePlaceholder": "e.g. Thread Color",
      "choiceMode": "Choice mode",
      "choiceModeLabels": {
        "multi": "Multiple choice",
        "single": "Single choice"
      },
      "required": "Required",
      "tierPricesTitle": "Tier prices (at least one row required)",
      "addTierRow": "+ Tier row",
      "pricePlaceholder": "Price (cents)",
      "remove": "Remove",
      "saving": "Saving…",
      "submit": "Create add-on",
      "empty": "No add-ons yet — create one above.",
      "yes": "Yes",
      "no": "No",
      "errTierRequired": "At least one tier-price row is required.",
      "toastCreated": "Add-on created",
      "toastCreateFailed": "Create add-on failed",
      "col": {
        "nameEn": "Name (EN)",
        "choice": "Choice",
        "required": "Required",
        "tierRows": "Tier rows"
      }
    }
  },
  "pricing": {
    "title": "Pricing",
    "subtitle": "Pricing tiers, deals, and shipping",
    "tabs": {
      "tiers": "Tiers",
      "deals": "Deals",
      "shipping": "Shipping",
      "shippingRates": "Shipping Rates",
      "history": "History"
    },
    "columns": {
      "name": "Name",
      "minQty": "Min Qty",
      "maxQty": "Max Qty",
      "price": "Price",
      "discount": "Discount"
    },
    "actions": {
      "createTier": "Create Tier",
      "createDeal": "Create Deal",
      "createShipping": "Create Shipping Rule",
      "edit": "Edit",
      "delete": "Delete"
    },
    "fields": {
      "tierName": "Tier Name",
      "qtyRange": "Quantity Range",
      "discountPct": "Discount %",
      "validFrom": "Valid From",
      "validTo": "Valid To"
    },
    "page": {
      "subtitle": "Manage pricing tiers (default: Standard — new tiers can be added), deals, shipping rates (7 zones × 2 speeds) and the change history. Price changes >±10% on Pricing Tiers require Super Admin approval.",
      "readonlyPre": "You don't have the",
      "readonlyPost": "permission. The page is read-only.",
      "tabsAria": "Pricing tabs"
    },
    "common": {
      "retry": "Retry",
      "cancel": "Cancel",
      "networkError": "Network error — check connection"
    },
    "dealsTab": {
      "heading": "Deals",
      "description": "Manage deals (volume / revenue / direct). New deals are always created as Draft; approval + activation happen in a separate review queue.",
      "createBtn": "+ Create Deal",
      "loadError": "Failed to load the Deals list.",
      "empty": "No deals yet.",
      "table": {
        "type": "Type",
        "reward": "Reward",
        "scope": "Scope",
        "valid": "Valid",
        "priority": "Priority",
        "status": "Status"
      },
      "scopeTiers": " · {{count}} tier(s)",
      "scopeMerchants": " · {{count}} merchant(s)",
      "scopeBlueprints": " · {{count}} blueprint(s)",
      "statusLabels": {
        "Active": "Active",
        "Draft": "Draft",
        "Paused": "Paused",
        "Expired": "Expired",
        "Archived": "Archived"
      },
      "validation": {
        "nameRequired": "Name (EN) is required",
        "priorityInt": "Priority must be an integer ≥ 0",
        "startRequired": "Start (Valid From) is required",
        "endRequired": "End (Valid Until) is required",
        "endAfterStart": "Valid Until must be later than Valid From",
        "cashbackBaseRequired": "cashback requires selecting a cashback base",
        "cashbackBaseInvalid": "cashback base is only valid when reward = cashback",
        "tierRequired": "Select at least 1 pricing tier",
        "blueprintOrMerchantRequired": "Select at least 1 blueprint or 1 merchant"
      },
      "toast": {
        "createdTitle": "Draft deal created",
        "createFailTitle": "Failed to create deal"
      },
      "modal": {
        "nameEn": "Name (EN) *",
        "type": "Type *",
        "dealScope": "Deal scope *",
        "rewardKind": "Reward kind *",
        "percent": "Percent %",
        "valueCents": "Value (cents)",
        "cashbackBase": "Cashback base *",
        "selectPlaceholder": "— select —",
        "scope": "Scope",
        "applyTo": "Apply to *",
        "pricingTiers": "Pricing tiers (multi-select)",
        "blueprints": "Blueprints (multi-select)",
        "searchBlueprint": "Search blueprint…",
        "merchantsOptional": "Merchants — optional (leave empty to target blueprints only)",
        "searchMerchant": "Search merchant…",
        "priority": "Priority *",
        "validFrom": "Valid From *",
        "validUntil": "Valid Until *",
        "expiryWarning": "Expiry warning (days)",
        "serverErrors": "Server errors:",
        "creating": "Creating…",
        "createDraft": "Create Draft"
      }
    },
    "historyTab": {
      "heading": "Pricing History",
      "descriptionPre": "Audit trail of pricing changes (Tiers / Variants). To see the full audit log, open Audit Logs with the filter ",
      "descriptionPost": ".",
      "auditLink": "Open Audit Logs (PricingTier) →",
      "loadError": "Failed to load Pricing History.",
      "empty": "No pricing changes yet.",
      "cols": {
        "changedAt": "Changed At",
        "tierVariant": "Tier / Variant",
        "before": "Before",
        "after": "After",
        "changedBy": "Changed By",
        "reason": "Reason",
        "source": "Source"
      },
      "tierLevel": "Tier-level",
      "variant": "Variant",
      "tierId": "tier: {{id}}",
      "variantIds": "bp: {{bp}} · var: {{var}} · tier: {{tier}}"
    },
    "reasonModal": {
      "title": "Confirm pricing change",
      "description": "A reason is required for every pricing change. Your input is written to the audit log alongside the new price.",
      "reasonLabel": "Reason",
      "placeholder": "e.g. Q3 cost increase per vendor invoice #12345",
      "needMoreOne": "Need at least {{count}} more character",
      "needMoreOther": "Need at least {{count}} more characters",
      "charCount": "{{count}} characters",
      "saving": "Saving…",
      "confirm": "Confirm change",
      "changes": {
        "sku": "SKU",
        "location": "Location",
        "tier": "Tier",
        "price": "Old → new price"
      },
      "batchSummary_one": "{{count}} price changed — one reason covers all of them.",
      "batchSummary_other": "{{count}} prices changed — one reason covers all of them."
    },
    "tiersTab": {
      "heading": "Pricing Tiers",
      "description": "Pricing tiers (default: Standard) — edit inline. Price changes >±10% require Super Admin approval.",
      "tierCount": "{{count}} tiers",
      "loadError": "Failed to load the Pricing Tiers list.",
      "empty": "No pricing tiers yet.",
      "cols": {
        "tier": "Tier",
        "status": "Status",
        "priority": "Priority",
        "conditions": "Conditions (Orders OR GMV)",
        "priceModifier": "Price Modifier (bps)",
        "actions": "Actions"
      },
      "statusLabels": {
        "Active": "Active",
        "Inactive": "Inactive"
      },
      "slugLabel": "slug: {{slug}}",
      "cond": {
        "orders": "Orders ≥ {{count}}",
        "gmv": "GMV ≥ ${{amount}}",
        "items": "Items ≥ {{count}}"
      },
      "priceModifierAria": "Price modifier % for {{name}}",
      "current": "Current: {{value}}",
      "modifierRange": "Enter a discount between -50% and 0% (markup not allowed).",
      "reasonPlaceholder": "Reason for change (≥ 10 characters — required to enable Save)",
      "reasonAria": "Reason for change",
      "reasonHint": "A reason of at least 10 characters is required ({{count}}/10) — Save enables when met.",
      "approvalTitle": "This change requires Super Admin approval",
      "approvalDelta": "Δ = {{pct}}% > ±10% threshold.",
      "submitting": "Submitting…",
      "submitForApproval": "Submit for approval",
      "saving": "Saving…",
      "save": "Save",
      "editHint": "— edit the value to make changes —",
      "readOnly": "Read-only (requires pricing:manage permission)",
      "footerNotePre": "The >±10% price threshold is automatic. The server re-checks it too; if you exceed the threshold, the banner shows the",
      "footerNoteMid": " button instead of ",
      "footerNotePost": ".",
      "toast": {
        "submittedTitle": "Submitted tier {{name}} for approval",
        "submittedDesc": "A Super Admin will approve the >±10% change.",
        "savedTitle": "Saved tier {{name}}",
        "saveFailTitle": "Failed to save tier {{name}}"
      }
    }
  },
  "technique": {
    "title": "Techniques",
    "subtitle": "Print and embroidery techniques",
    "tabs": {
      "print": "Print",
      "embroidery": "Embroidery"
    },
    "columns": {
      "name": "Name",
      "type": "Type",
      "basePrice": "Base Price",
      "isActive": "Active"
    },
    "actions": {
      "create": "Create Technique",
      "edit": "Edit",
      "delete": "Delete"
    },
    "detail": {
      "toast": {
        "saved": "Saved",
        "saveFailed": "Save failed",
        "deleted": "Technique deleted",
        "deleteFailed": "Delete failed"
      },
      "notFound": "Technique not found.",
      "backToList": "Back to list",
      "back": "Back to Techniques",
      "active": "Active",
      "inactive": "Inactive",
      "inactiveDraft": "Inactive (draft)",
      "codeImmutable": "Code (immutable)",
      "typeImmutable": "Type (immutable)",
      "nameEn": "Name (EN)",
      "nameVi": "Name (VI)",
      "nameFr": "Name (FR)",
      "activeToggleAria": "Active toggle",
      "digitizingFee": "Digitizing fee (USD cents)",
      "stitchRanges": "Stitch ranges",
      "addRange": "Add range",
      "rangeMin": "Min stitches",
      "rangeMax": "Max stitches",
      "rangeFee": "Fee (cents)",
      "remove": "Remove",
      "overflowTitle": "Over-cap overflow formula",
      "overflowPer": "Per stitches (Y)",
      "overflowFee": "Fee cents (X)",
      "overflowDisabled": "Disabled — no extra charge beyond the last band.",
      "noPricingCutting": "Cutting currently has no pricing fields.",
      "noPricingBlank": "Blank methods have no pricing fields.",
      "noPricingPrint": "Print methods have no pricing fields. Pricing lives on blueprints / products.",
      "cancel": "Cancel",
      "save": "Save",
      "saving": "Saving…",
      "deleteTitle": "Delete technique?",
      "deleteDesc": "Soft-delete this technique. It is hidden from the list and can be restored from the database."
    },
    "createModal": {
      "subtitle": "Pick a type — Embroidery requires stitch-range pricing + digitizing fee.",
      "typeOptions": {
        "print": "Print (UV / DTF / DTG / Sublimation)",
        "embroidery": "Embroidery (stitch-range + digitizing fee)",
        "cutting": "Cutting (laser / etch — pricing MVP-C)",
        "blank": "Blank (no pricing)"
      },
      "code": "Code",
      "codePlaceholder": "e.g. dtg, sublimation",
      "codeHint": "Slug: lowercase letters / digits / dashes / underscores, max 50.",
      "activeOnCreation": "Active on creation",
      "digitizingFeeHint": "Required for embroidery — charged once per artwork.",
      "rangeRowHint": "Each row:",
      "printNote": "Print methods have no extra fields. Pricing lives on blueprints / products.",
      "cuttingNoteBefore": "Cutting currently has no extra fields.",
      "cuttingNoteAfter": "schema is deferred to MVP-C. Pricing rules added there.",
      "blankNoteBefore": "Blank methods have",
      "blankNoteStrong": "no pricing fields",
      "blankNoteAfter": "(backend rejects digitizingFee / embroideryRanges / overflow).",
      "creating": "Creating…",
      "submit": "Create technique",
      "toast": {
        "created": "Technique created",
        "createFailed": "Create technique failed",
        "createFailedFallback": "Create failed"
      }
    },
    "create": {
      "titleFallback": "New embroidery technique",
      "basicInfo": "Basic Information",
      "name": "Name",
      "namePlaceholder": "Enter technique name",
      "code": "Code",
      "codePlaceholder": "Enter code",
      "codeDuplicate": "Code already in use.",
      "description": "Description",
      "descriptionPlaceholder": "Enter description",
      "digitizingFee": "File digitization fee",
      "firstArea": "First embroidery area",
      "nextArea": "Next embroidery area",
      "nextAreaHint": "Optional. Tick an area to price it separately; unticked areas use the pricing above.",
      "applyPriceToAll": "Apply this pricing to {{count}} selected area(s)",
      "applyToAllDisabledHint": "Tick at least one area first.",
      "selectAll": "Select all",
      "areaLabel": "Area: {{area}}",
      "areasLoading": "Loading print areas…",
      "areasLoadFailed": "Could not load print areas.",
      "areasEmpty": "No print areas configured yet.",
      "addRange": "Add",
      "rangeMin": "Minimum stitches",
      "rangeMax": "Maximum stitches",
      "rangeFee": "Embroidery fee",
      "remove": "Remove row",
      "overflowEvery": "For every additional",
      "overflowStitchesAdd": "stitches, add",
      "overflowPer": "Additional stitches per step",
      "overflowFee": "Fee added per step",
      "save": "Save",
      "saving": "Saving…",
      "toast": {
        "created": "Technique created",
        "createFailed": "Create technique failed",
        "createFailedFallback": "Create failed",
        "incomplete": "Cannot save yet",
        "incompleteDesc": "Some required fields are missing or invalid — they are highlighted below.",
        "saved": "Technique saved",
        "saveFailed": "Save technique failed"
      },
      "rangeError": "Each row needs a maximum greater than the minimum, and a fee of $0 or more.",
      "overflowError": "Fill both fields to charge past the last row, or clear both to charge nothing.",
      "codeLocked": "Code cannot be changed after creation.",
      "breadcrumbAria": "Breadcrumb",
      "crumbBlueprint": "Blueprint",
      "crumbCreate": "Create",
      "crumbEdit": "Edit",
      "bulkPricing": {
        "title": "Bulk price edit",
        "description": "Enter one pricing table and apply it to all {{count}} selected area(s).",
        "overwriteWarning": "This replaces the pricing of every selected area. Areas you have not ticked are left untouched.",
        "apply": "Apply to {{count}} area(s)",
        "cancel": "Cancel",
        "invalidHint": "Fix the pricing table before applying it."
      }
    },
    "cuttingMethods": {
      "heading": "Cutting Methods",
      "caption": "Laser / Etch / Mechanical (pricing per area defer MVP-C)",
      "banner": "Pricing per cut area (cuttingRanges) defer to MVP-C — list shows only name/code/active toggle.",
      "codeAria": "Code (slug)",
      "codePlaceholder": "code (e.g. laser)",
      "namePlaceholder": "Display name (English)",
      "addBtn": "Add cutting technique",
      "colCode": "Code",
      "colActions": "Actions",
      "loading": "Loading…",
      "empty": "No cutting methods yet — add one above.",
      "activeToggleTitleActive": "Active — click to deactivate",
      "activeToggleTitleInactive": "Inactive — click to activate",
      "activeToggleAria": "Active toggle for {{code}}",
      "confirmDelete": "Delete cutting method \"{{code}}\"?",
      "toast": {
        "created": "Cutting method created",
        "deleted": "Cutting method deleted",
        "createFailed": "Create cutting method failed",
        "createFailedFallback": "Create failed"
      }
    },
    "printMethods": {
      "heading": "Print Methods",
      "caption": "UV / DTF / DTG / Sublimation",
      "codeAria": "Code (slug)",
      "codePlaceholder": "code (e.g. dtg)",
      "namePlaceholder": "Display name (English)",
      "addBtn": "Add print method",
      "colCode": "Code",
      "colActions": "Actions",
      "loading": "Loading…",
      "empty": "No print methods yet — add one above.",
      "activeToggleTitleActive": "Active — click to deactivate",
      "activeToggleTitleInactive": "Inactive — click to activate",
      "activeToggleAria": "Active toggle for {{code}}",
      "confirmDelete": "Delete print method \"{{code}}\"?",
      "toast": {
        "created": "Print method created",
        "deleted": "Print method deleted",
        "createFailed": "Create print method failed",
        "createFailedFallback": "Create failed"
      }
    },
    "embroideryMethods": {
      "heading": "Embroidery Methods",
      "loading": "Loading…",
      "colMinStitches": "Min Stitches",
      "colMaxStitches": "Max Stitches",
      "colFeeCents": "Fee (USD cents)",
      "colFeeDisplay": "Fee (display)",
      "colActions": "Actions",
      "feeCentsAria": "Fee in cents",
      "saveRanges": "Save stitch ranges",
      "overflowDescBefore": "Beyond the last band's maxStitches, fee scales as",
      "overflowDescStrong": "+$X per +Y stitches",
      "overflowPerAria": "Overflow per stitches",
      "overflowFeeAria": "Overflow fee cents",
      "globalDigitizingFee": "Global digitizing fee",
      "digitizingFeeHint": "Charged once per artwork.",
      "digitizingFeeAria": "Digitizing fee in cents",
      "saveDigitizingFee": "Save digitizing fee",
      "toast": {
        "stitchRangesSaved": "Stitch ranges saved",
        "stitchRangesSaveFailed": "Save stitch ranges failed",
        "digitizingFeeSaved": "Digitizing fee saved",
        "digitizingFeeSaveFailed": "Save digitizing fee failed",
        "invalidRangesTitle": "Invalid stitch ranges",
        "invalidRangesDesc": "Each row needs valid min/max/fee values; overflow needs perStitches ≥ 1 + feeCents ≥ 0.",
        "invalidFeeTitle": "Invalid digitizing fee",
        "invalidFeeDesc": "Must be a non-negative integer (cents)."
      }
    },
    "table": {
      "activate": "Activate",
      "activateDesc": "\"{{name}}\" ({{code}}) will become selectable in product pickers.",
      "activateTitle": "Activate technique?",
      "activeToggleAria": "Active toggle for {{code}}",
      "allTypes": "All types",
      "bandCountOne": "{{count}} band",
      "bandCountOther": "{{count}} bands",
      "colAction": "Action",
      "colCode": "Code",
      "colCreatedBy": "Created by",
      "colCreatedDate": "Created date",
      "colCreator": "Creator",
      "colDescription": "Description",
      "colLastUpdate": "Last update",
      "colName": "Name",
      "colNameCode": "Name / Code",
      "colUpdatedBy": "Updated by",
      "deactivate": "Deactivate",
      "deactivateDesc": "\"{{name}}\" ({{code}}) will be hidden from product pickers until reactivated.",
      "deactivateTitle": "Deactivate technique?",
      "descBlank": "Blank — no pricing",
      "descCutting": "Cutting method (pricing MVP-C)",
      "descPrint": "Print method",
      "digitizingFeeLabel": "Digitizing fee:",
      "editAria": "Edit technique {{code}}",
      "empty": "No techniques match the current filters.",
      "loadError": "Failed to load techniques.",
      "loading": "Loading…",
      "newBtn": "Create Technique",
      "nextPage": "Next page",
      "noDigitizingFee": "No digitizing fee",
      "overflowLabel": "Overflow:",
      "overflowPer": "per",
      "overflowUnit": "st",
      "paginationAria": "Techniques pagination",
      "prevPage": "Previous page",
      "retry": "Retry",
      "rowsPerPage": "Rows per page:",
      "searchAria": "Search by code or name",
      "searchLabel": "Search",
      "searchPlaceholder": "Search by code, name…",
      "showingRange": "Showing {{from}}–{{to}} of {{total}} techniques",
      "statusDeleted": "Deleted",
      "statusFilterAll": "Status: All",
      "statusFilterAria": "Filter by status",
      "statusLabel": "Status",
      "subtitle": "Manage your printing and embroidery techniques, configurations, and production methods.",
      "toast": {
        "statusUpdated": "Status updated",
        "toggleFailed": "Toggle active failed"
      },
      "typeLabels": {
        "print": "Print",
        "embroidery": "Embroidery",
        "cutting": "Cutting",
        "blank": "Blank"
      },
      "working": "Working…"
    },
    "treeSelect": {
      "placeholder": "— Select print / embroidery techniques —",
      "selectedCount": "{{count}} selected",
      "removeAria": "Remove {{name}}",
      "loading": "Loading techniques…",
      "loadError": "Failed to load techniques.",
      "empty": "No active techniques configured.",
      "selectAll": "Select all",
      "deselectAll": "Deselect all",
      "clearAll": "Clear all",
      "typeLabels": {
        "print": "Print",
        "embroidery": "Embroidery",
        "cutting": "Cutting",
        "blank": "Blank",
        "engraving": "Engraving"
      }
    },
    "form": {
      "addRange": "Add range",
      "cancel": "Cancel",
      "code": "Code",
      "codeHint": "Letters, digits, hyphen and underscore. Stored in lower case.",
      "codeLocked": "Code cannot be modified after creation.",
      "codePlaceholder": "Enter technique code (e.g. DTG-001)",
      "createSubtitle": "Add a new printing or embroidery technique to the system.",
      "createTitle": "Create Printing Technique",
      "createTitleEmbroidery": "Create Embroidery Technique",
      "description": "Description",
      "descriptionPlaceholder": "Enter a brief description of this technique",
      "digitizingFee": "Digitizing fee (cents)",
      "editSubtitle": "Update technique details and configuration.",
      "editTitle": "Edit Printing Technique",
      "editTitleEmbroidery": "Edit Embroidery Technique",
      "embroideryRequiredNote": "Embroidery techniques need a digitizing fee and at least one stitch range before they can be saved. Overflow pricing is set on the technique page.",
      "name": "Name",
      "namePlaceholder": "Enter technique name",
      "rangeFee": "Fee (cents)",
      "rangeHint": "Each range needs max greater than min, and a fee of zero or more.",
      "rangeMax": "Maximum stitches",
      "rangeMin": "Minimum stitches",
      "removeRange": "Remove",
      "save": "Save",
      "saveFailed": "Could not save the technique",
      "stitchRanges": "Stitch ranges",
      "toastCreated": "Technique created",
      "toastUpdated": "Technique updated"
    }
  },
  "template": {
    "title": "Templates",
    "subtitle": "Template artwork management",
    "columns": {
      "name": "Name",
      "blueprint": "Blueprint",
      "regions": "Regions",
      "updatedAt": "Updated"
    },
    "actions": {
      "create": "Create Template",
      "edit": "Edit",
      "regionErrors": "Region Errors",
      "preview": "Preview"
    },
    "regionErrors": {
      "title": "Region Errors",
      "lowOpacity": "Low opacity detected — artwork may not print well",
      "outsideRegion": "Element is outside the print region",
      "missingArtwork": "Region has no artwork",
      "description": "Catalog of errors assigned to template regions (thin lines, wrong template…). Artwork Doctor uses them to block/warn when a merchant uploads.",
      "newError": "+ New error",
      "empty": "No region errors yet.",
      "edit": "Edit",
      "delete": "Delete",
      "cancel": "Cancel",
      "save": "Save",
      "saving": "Saving…",
      "confirmDeleteTitle": "Delete region error?",
      "confirmDeleteBody": "The error will be removed from the catalog and stripped from every template using it (cascade).",
      "col": {
        "key": "Key",
        "label": "Label",
        "severity": "Severity",
        "actions": "Actions"
      },
      "severity": {
        "errorShort": "Error (blocks)",
        "warningShort": "Warning",
        "errorOption": "Error (blocks artwork)",
        "warningOption": "Warning (soft)"
      },
      "dialog": {
        "editTitle": "Edit region error",
        "newTitle": "New region error",
        "keyLabel": "Key *",
        "keyPlaceholder": "e.g. thin_lines",
        "labelEnLabel": "Label (EN) *",
        "labelViLabel": "Label (VI)",
        "severityLabel": "Severity"
      },
      "toast": {
        "loadFailed": "Failed to load the region error list",
        "keyLabelRequired": "Key and Label (EN) are required",
        "saveFailed": "Save failed",
        "updated": "Region error updated",
        "created": "Region error created",
        "deleteFailed": "Delete failed",
        "deleted": "Region error deleted"
      }
    },
    "detail": {
      "back": "← List",
      "backToList": "← Back to list",
      "notFound": "Template not found.",
      "deleteBtn": "Delete template",
      "resyncTooltip": "Push the current spec to Artwork Doctor",
      "resyncing": "Pushing…",
      "resync": "Re-sync AD",
      "saving": "Saving…",
      "save": "Save changes",
      "confirmDeleteTitle": "Delete template?",
      "confirmDeleteBody": "Soft-delete the template — it can be restored from the \"Show deleted\" filter.",
      "confirmDeleteYes": "Delete",
      "confirmDeleteNo": "Cancel",
      "staleBanner": "This template was updated by someone else. Reload to get the latest version before saving (unsaved changes will be lost).",
      "reload": "Reload",
      "generalInfo": "General information",
      "nameEn": "Name (EN) *",
      "code": "Code *",
      "aliasEn": "Alias (EN)",
      "type": "Type *",
      "side": "Side",
      "productKind": "Product kind *",
      "nameVi": "Name (VI)",
      "printTechnology": "Print technology",
      "printTechnologyHint": "Select the print technologies this template supports (DTG/DTF/UV/Sublimation). A template can support several.",
      "descriptionEn": "Description (EN)",
      "isActive": "Active",
      "areaDetail": "Area detail",
      "selectAll": "All",
      "analyzing": "Detecting regions…",
      "uploading": "Uploading image…",
      "invalidData": "Invalid data.",
      "groupFailed": "These regions cannot be grouped",
      "toast": {
        "saved": "Template saved",
        "savedWarnings": "Warnings: {{warnings}}",
        "savedCode": "Code: {{code}}",
        "staleTitle": "Record changed",
        "saveFailed": "Failed to save template",
        "deleted": "Template deleted",
        "deletedDesc": "Soft-deleted — it can be restored from the \"Show deleted\" filter.",
        "deleteFailed": "Failed to delete template",
        "resyncFailed": "Artwork Doctor re-sync failed",
        "adDisabled": "Artwork Doctor is disabled",
        "adDisabledReason": "Artwork Doctor is disabled — spec was not pushed.",
        "pushed": "Spec pushed to Artwork Doctor"
      },
      "errors": {
        "network": "Connection error — check your network and try again.",
        "fieldRequired": "{{field}} is a required field",
        "fieldInvalid": "{{field}} is invalid — {{reason}}",
        "atPart": "Part {{n}}",
        "atLayer": "Layer {{n}}",
        "atRegion": "Region {{n}}",
        "atArea": "Area {{n}}",
        "areaIncomplete": "Area {{n}}: {{fields}} — required before you can save",
        "unknownArea": "{{field}} is not in the Print Areas catalog — pick one from the list",
        "andMore": "…and {{n}} more problem(s)",
        "noArea": "Template must have at least one print area before it can be saved."
      },
      "validation": {
        "artworkNoRegion": "Artwork layer in part \"{{part}}\" needs at least one print region with a size.",
        "artworkNoFile": "Artwork layer in part \"{{part}}\" needs at least one file."
      },
      "fields": {
        "area": "Area",
        "bbox": "Bounding box",
        "code": "Code",
        "name": "Name",
        "label": "Label",
        "technique": "Technique",
        "regions": "Regions",
        "areas": "Areas",
        "layers": "Layers",
        "parts": "Parts",
        "type": "Type",
        "productKind": "Product kind",
        "side": "Side",
        "material": "Material",
        "role": "Role",
        "imageUrl": "Image",
        "validationRules": "Validation rules",
        "width": "Width",
        "height": "Height",
        "ppi": "PPI",
        "fileFormats": "File formats"
      }
    },
    "wizard": {
      "pageTitle": "Create new template",
      "pageSubtitle": "Declare general info, parts/layers and validation. Area images are added on the detail page after saving.",
      "cancel": "Cancel",
      "back": "← Back",
      "next": "Continue →",
      "submit": "Create template",
      "submitting": "Creating…",
      "stepCounter": "Step {{current}} / {{total}}",
      "stepperAria": "Template creation progress",
      "generalInfo": "General info",
      "steps": {
        "info": "General info",
        "parts": "Parts & Layers",
        "validation": "Validation & Canvas"
      },
      "fields": {
        "nameEn": "Name (EN) *",
        "code": "Code *",
        "codePlaceholder": "auto-generated-from-name",
        "codeHint": "Auto-generated from Name (EN). Editable. Only a-z, A-Z, 0-9, underscore or hyphen (1-50 characters).",
        "aliasEn": "Alias (EN)",
        "type": "Type *",
        "side": "Side",
        "productKind": "Product kind *",
        "nameVi": "Name (VI)",
        "printTechnology": "Print technology",
        "printTechnologyHint": "Select the print technologies this template supports (DTG/DTF/UV/Sublimation).",
        "descriptionEn": "Description (EN)",
        "isActive": "Active"
      },
      "areaImageUploadFailed": "Area image upload failed",
      "invalidData": "Invalid data.",
      "createdTitle": "Template created",
      "createdDesc": "Code: {{code}}. Continue adding area images / regions on the detail page.",
      "createFailed": "Failed to create template",
      "errors": {
        "network": "Connection error — check your network and try again."
      }
    },
    "opacityPreview": {
      "areaPreviewAria": "Template area preview: {{code}}",
      "noImage": "No template image yet",
      "dropHint": "Drag & drop a PNG file here or click to choose a file. Up to 50 MB.",
      "chooseFile": "Choose file",
      "regionsCountOne": "{{count}} region",
      "regionsCountOther": "{{count}} regions",
      "replacePng": "Replace PNG",
      "status": {
        "preflight": "Checking file",
        "decoding": "Decoding PNG",
        "classify": "Scanning opacity",
        "label": "Splitting regions",
        "summarize": "Summarizing results"
      },
      "warningLabel": "Warning:",
      "outOfRangeWarning": "{{count}} pixels fall outside the 5 valid opacity levels (±2% tolerance). The PNG file must use exactly 5 opacity levels (0% / 40% / 60% / 80% / 100%). You cannot save the template until the PNG file is fixed.",
      "artworkAlt": "Template area artwork",
      "selectRegionAria": "Select region {{bucket}}",
      "bucket": {
        "1": "Background",
        "2": "Print: Safe zone",
        "3": "Print: Normal",
        "4": "Cut: Die-cut",
        "5": "Cut: Normal"
      }
    },
    "gridOverlay": {
      "uploadHint": "Upload a template image to see the print regions",
      "contoursAlt": "Template with contours",
      "flipTitle": "Flip {{name}} in {{group}}",
      "overlapDetectedOne": "{{count}} partial overlap detected",
      "overlapDetectedOther": "{{count}} partial overlaps detected",
      "regionTypes": {
        "C": "Cut",
        "D": "Die cut",
        "P": "Print",
        "S": "Safe zone",
        "X": "Unusable"
      }
    },
    "nested": {
      "checkManifest": {
        "heading": "Check Manifest (Artwork Doctor)",
        "addLabel": "Add check (pick a check type)",
        "loadingOption": "Loading…",
        "selectPlaceholder": "— pick a check type —",
        "paramsSuffix": " · params",
        "add": "+ Add",
        "empty": "No checks attached yet. Pick a check type above to add one.",
        "enabled": "enabled",
        "remove": "Delete",
        "severity": "severity",
        "severityOptions": {
          "error": "error",
          "warning": "warning"
        },
        "part": "part",
        "selectPart": "— pick a part —",
        "layer": "layer (zIndex)",
        "selectLayer": "— pick a layer —",
        "region": "region",
        "selectRegion": "— pick a region —",
        "params": "Params"
      },
      "layerForm": {
        "zIndex": "zIndex *",
        "material": "Material *",
        "role": "Role *",
        "thickness": "thicknessMm",
        "printSides": "printSides",
        "printSidesCutOnly": "0 (cut-only)",
        "alignTo": "alignTo (layer ref)",
        "alignToNone": "— none —",
        "alignToSymmetric": "symmetric",
        "files": "Files",
        "addFile": "+ File",
        "noFiles": "No files yet.",
        "fileKind": "kind",
        "fileSurface": "surface",
        "imageUrl": "imageUrl",
        "pngButton": "PNG…",
        "removeFile": "Delete file",
        "opacityError": "Opacity-detect failed.",
        "opacityResult": "Detected {{count}} region(s) from the PNG.",
        "opacityBlocked": " (Pixels out of range — review before saving.)",
        "mergeRegions": "Add to regions",
        "opacityProgress": "Analyzing PNG… {{progress}}%",
        "regions": "Regions",
        "addRegion": "+ Region",
        "noRegions": "No regions yet.",
        "removeLayer": "Delete layer"
      },
      "partAccordion": {
        "heading": "Parts → Layers → Regions",
        "addPart": "+ Add part",
        "empty": "No parts yet. Add a part to get started.",
        "noCode": "(no code)",
        "layerCount": "({{count}} layers)",
        "defaultBadge": "default",
        "legacyBadge": "legacy non-default part",
        "removePart": "Delete part",
        "code": "Code * (slug)",
        "sortOrder": "sortOrder",
        "isDefault": "isDefault",
        "hasStand": "hasStand",
        "resizeArtwork": "Resize Artwork (AD auto-scales)",
        "anchorSize": "Anchor size (original size, e.g. 12x12)",
        "label": "Label ({{lang}}{{required}})",
        "layers": "Layers",
        "addLayer": "+ Add layer",
        "noLayers": "No layers yet.",
        "regionCount": "({{count}} regions)"
      },
      "regionErrorAssign": {
        "heading": "Region errors (assign from catalog)",
        "loading": "Loading catalog…",
        "empty": "The catalog has no errors yet. Create one in “Region errors” (header)."
      },
      "regionForm": {
        "labelEn": "Label (EN)",
        "kind": "Kind *",
        "technique": "Technique",
        "techniqueBackground": "— (background) —",
        "bbox": "bbox {{coord}}",
        "gridX": "gridX",
        "gridY": "gridY",
        "locked": "Locked",
        "contour": "Contour (JSON: [[x,y], …] — paste + validate)",
        "dependsOn": "dependsOn (region refs)",
        "removeRegion": "Delete region"
      }
    },
    "canvas": {
      "areaBlock": {
        "addArea": "Add area",
        "activateAreaAria": "Activate area {{n}}",
        "areaTitle": "Area {{n}}",
        "uploadAria": "Upload template image",
        "upload": "Upload",
        "removeAreaAria": "Remove area",
        "required": "Required",
        "area": "Area",
        "fileFormat": "File format",
        "regionsTitle": "Regions ({{count}})",
        "regionsEmpty": "No regions defined for this area yet.",
        "regionRequired": "Required",
        "regionOptional": "Optional",
        "toggleRegionsAria": "Show or hide regions for area {{n}}"
      },
      "areaFields": {
        "selectArea": "Select area…",
        "all": "All",
        "widthPx": "Width (px)",
        "heightPx": "Height (px)",
        "dpi": "DPI"
      },
      "areaImageUpload": {
        "groupAria": "Area background image",
        "uploadLabel": "Upload template image",
        "remove": "Remove",
        "previewAlt": "Area background preview",
        "noRouteTitle": "No FE-reachable download route for this GridFS id (R2)",
        "previewUnavailable": "Preview unavailable — upload endpoint pending",
        "dropzoneAria": "Click or drag to upload template image",
        "uploading": "Uploading…",
        "clickOrDrag": "Click or drag to upload",
        "uploadEndpointPending": "Upload endpoint pending"
      },
      "actionButtons": {
        "mismatch": "Mismatch ({{count}})",
        "semiFinish": "Semi-finish ({{count}})",
        "ungroup": "Ungroup"
      },
      "groupList": {
        "regionOne": "{{count}} region",
        "regionOther": "{{count}} regions",
        "material": "Material",
        "none": "— None —",
        "selectRegionsTitle": "Click to select the regions in this group",
        "mismatchNoMaterial": "Mismatch — no material needed",
        "flip": "Flip",
        "empty": "No groups — select ≥2 regions then Semi-finish / Mismatch.",
        "materialOptions": {
          "wood": "Wood",
          "acrylic": "Acrylic"
        }
      },
      "areaDetail": {
        "legendCut": "C: Cut ({{count}})",
        "legendPrint": "P: Print ({{count}})",
        "all": "All",
        "canvasAria": "Area regions canvas",
        "noRegion": "No regions yet"
      },
      "regionBatchEdit": {
        "title": "Region detail",
        "selectedCountOne": "Selected {{count}} region",
        "selectedCountOther": "Selected {{count}} regions",
        "deselectAll": "Deselect all",
        "emptyPrompt": "Select a region on the canvas to edit",
        "label": "Label",
        "technique": "Technique",
        "required": "Required",
        "modeLabel": {
          "label": "Label, Required, Error",
          "required": "Required",
          "regionError": "Region error"
        }
      },
      "regionErrorChecklist": {
        "heading": "Region errors (batch assign)",
        "loading": "Loading catalog…",
        "empty": "No errors in the catalog yet. Create them in “Region errors” (header).",
        "severity": {
          "error": "error",
          "warning": "warning"
        }
      },
      "regionFieldDropdowns": {
        "mixed": "— Mixed —",
        "noLabel": "(no label)",
        "techniqueLabel": {
          "printNormal": "Print: Normal",
          "printSafeZone": "Print: SafeZone",
          "cutNormal": "Cut: Normal",
          "cutDieCut": "Cut: DieCut",
          "engraveNormal": "Engrave: Normal",
          "engraveDeep": "Engrave: Deep",
          "background": "(background)"
        }
      },
      "validationDetail": {
        "name": "Name",
        "namePlaceholder": "Validation name",
        "title": "Validation detail",
        "export": "Export",
        "default": "Default",
        "resize": "Resize",
        "empty": "No validation yet — click + to create one"
      },
      "validationTabs": {
        "tabAria": "Validation {{index}}",
        "defaultStarAria": "Default validation",
        "deleteAria": "Delete validation",
        "addAria": "Add validation",
        "confirmDeleteTitle": "Delete validation?",
        "confirmDeleteBefore": "Deleting \"",
        "confirmDeleteAfter": "\" removes this validation rule and all of its areas. This cannot be undone until you save."
      },
      "groupConflict": {
        "semiConflict": "The selected regions already belong to another semi-finish group.",
        "mismatchConflict": "The selected regions already belong to another mismatch group.",
        "semiCannotMismatch": "Regions in the same semi-finish group cannot be grouped as mismatch together.",
        "mismatchCannotSemi": "Regions in the same mismatch group cannot be grouped as semi-finish together.",
        "mismatchMinRegions": "Mismatch requires at least 2 regions selected.",
        "noMatch": "The selected regions do not match any group to ungroup."
      },
      "regionBox": {
        "needFlipAria": "Needs flip (mirror)"
      }
    },
    "contour": {
      "invalidJson": "Invalid JSON: {{detail}}",
      "invalidJsonShort": "Invalid JSON",
      "mustBePairs": "contour must be an array of number pairs [[x,y], …]"
    },
    "createDialog": {
      "namePlaceholder": "My Template"
    }
  },
  "option": {
    "title": "Manage Options",
    "subtitle": "Manage product attributes and the Label catalog that groups them.",
    "loading": "Loading…",
    "createdByAdmin": "Admin",
    "editAria": "Edit {{name}}",
    "editTitle": "Edit option + values",
    "tabs": {
      "options": "Options",
      "labels": "Labels"
    },
    "search": {
      "placeholder": "Search by name..."
    },
    "filter": {
      "allLabels": "All Labels"
    },
    "columns": {
      "label": "Label",
      "name": "Option Name",
      "values": "Values",
      "createdDate": "Created Date",
      "createdBy": "Created/Updated By",
      "actions": "Actions"
    },
    "empty": {
      "none": "No options yet. Use \"+ Add New\" to create one.",
      "noMatch": "No options match the current filter."
    },
    "footer": {
      "total": "Total: {{count}}",
      "show": "Show:"
    },
    "types": {
      "color": "Color",
      "size": "Size",
      "dimension": "Dimension",
      "text": "Text"
    },
    "status": {
      "active": "Active",
      "inactive": "Inactive"
    },
    "fields": {
      "code": "Code",
      "label": "Label",
      "status": "Status"
    },
    "actions": {
      "addNew": "+ Add New",
      "cancel": "Cancel",
      "save": "Save",
      "edit": "Edit",
      "close": "Close",
      "enable": "Enable",
      "disable": "Disable",
      "deleteOption": "Delete option"
    },
    "pagination": {
      "first": "First",
      "previous": "Previous",
      "next": "Next",
      "last": "Last"
    },
    "values": {
      "none": "— no values —",
      "more": "+{{count}} more",
      "title": "Values",
      "dialogTitle": "Values of {{name}}",
      "dialogAria": "All values of this option",
      "dialogCount": "{{count}} values",
      "dialogClose": "Close"
    },
    "create": {
      "title": "Create new option",
      "aria": "Create option",
      "nameEnLabel": "Option name (EN)",
      "nameEnPlaceholder": "e.g. Apparel Color",
      "nameViLabel": "Option name (VI)",
      "nameViPlaceholder": "e.g. Màu áo",
      "codePlaceholder": "auto-derived from name",
      "codeHint": "lowercase_snake_case, immutable after create.",
      "submit": "Create option",
      "submitting": "Creating…"
    },
    "edit": {
      "title": "Edit option — {{name}}",
      "aria": "Edit option {{name}}",
      "nameEnLabel": "Name (EN)",
      "nameViLabel": "Name (VI)",
      "labelCode": "Label / Code",
      "immutable": "Immutable after creation.",
      "noChanges": "No changes to save",
      "save": "Save changes",
      "saving": "Saving…"
    },
    "value": {
      "labelEnLabel": "Label (EN)",
      "labelEnPlaceholder": "e.g. Yellow",
      "labelViLabel": "Label (VI)",
      "labelViPlaceholder": "e.g. Vàng",
      "codePlaceholder": "auto",
      "add": "+ Add value",
      "adding": "Adding…",
      "loading": "Loading values…",
      "empty": "No values yet — add one above.",
      "columns": {
        "label": "Label",
        "position": "Position",
        "status": "Status"
      },
      "hexLabel": "Hex color",
      "hexPlaceholder": "#FF0000",
      "hexInvalid": "Invalid hex color — use format #RRGGBB",
      "hexNLabel": "Color {{n}}",
      "hexOptional": "optional",
      "swatchImageLabel": "Swatch image",
      "swatchUpload": "Upload",
      "swatchUploading": "Uploading…",
      "swatchPreview": "Preview",
      "swatchUploadFailed": "Swatch upload failed"
    },
    "confirm": {
      "deleting": "Deleting…",
      "deleteOptionTitle": "Delete option \"{{name}}\"?",
      "deleteOptionDesc": "Existing variants using this option cannot be modified afterwards. The action is permanent.",
      "deleteValue": "Delete value",
      "deleteValueTitle": "Delete value \"{{label}}\"?",
      "deleteValueDesc": "If this value is bound to an existing SKU the server will block the delete with a 409 error. Otherwise the value is removed immediately."
    },
    "toast": {
      "nameRequired": "Name required",
      "nameRequiredDesc": "Enter the option name (EN).",
      "created": "Option created",
      "createdDesc": "{{name}} ready to use.",
      "createFailed": "Create failed",
      "networkError": "Network error",
      "updated": "Option updated",
      "saveFailed": "Save failed",
      "deleted": "Option deleted",
      "deleteFailed": "Delete failed",
      "labelRequired": "Label required",
      "valueAdded": "Value added",
      "addValueFailed": "Add value failed",
      "valueUpdated": "Value updated",
      "saveValueFailed": "Save value failed",
      "valueDeleted": "Value deleted",
      "deleteValueFailed": "Delete value failed",
      "toggleFailed": "Toggle failed"
    },
    "variantsFacetAssign": {
      "saveSuccess": "Assignment saved",
      "saveErrorTitle": "Could not save assignment",
      "networkCheckError": "Network error — check connection",
      "title": "Assign merchants — {{name}}",
      "hint": "Flipped layout — pick variants first, then pick merchants to bulk-apply. {{count}} variants total.",
      "selectVariantsHeading": "1. Select variants ({{count}} selected)",
      "selectAllVisible": "Select all visible",
      "clearSelected": "Clear ({{count}})",
      "variantSearchPlaceholder": "Search variant…",
      "axis": {
        "color": "Color",
        "size": "Size"
      },
      "axisOption": "{{label}}: all",
      "showHidden": "Show hidden",
      "noVariantMatch": "No variants match the filter.",
      "hiddenBadge": "Hidden",
      "selectMerchantsHeading": "2. Select merchants ({{count}} selected)",
      "merchantSearchPlaceholder": "Search merchant…",
      "noMerchant": "No merchants.",
      "bulkApplyLabel": "Bulk apply: {{variants}} variant × {{merchants}} merchant",
      "bulkApplyHint": "Merge with the current assignment (won't clobber merchants already assigned to other variants).",
      "saving": "Saving…",
      "apply": "Apply",
      "currentToggle": "Current assignments — {{blueprint}} blueprint-level · {{variant}} variant-level",
      "noAssignment": "No assignments yet.",
      "blueprintLevel": "Blueprint-level:",
      "merchantCount": "{{count}} merchant",
      "close": "Close",
      "loadingMerchants": "Loading merchants…",
      "directoryError": "Could not load the merchant directory. Check your connection and try again.",
      "noSearchMatch": "No merchant matches “{{term}}”.",
      "selectedAcrossPages": "{{count}} merchant(s) selected, including any on other pages."
    },
    "variantsFacetTable": {
      "axis": {
        "color": "Color",
        "size": "Size",
        "stockStatus": "Stock"
      },
      "axisOption": "{{label}}: all",
      "warningHuge": "⚠ {{count}} SKUs — Warning >500 variants",
      "warningLarge": "⚠ {{count}} SKUs (large blueprint)",
      "searchPlaceholder": "Search SKU / color / size…",
      "clearFilters": "Clear filters",
      "showingCount": "Showing {{shown}} of {{total}}",
      "colSku": "SKU",
      "colColor": "Color",
      "colSize": "Size",
      "colStock": "Stock",
      "colMerchants": "Merc.",
      "noVariantMatch": "No variants match the filter.",
      "stockStatus": {
        "Discontinued": "Discontinued",
        "Hidden": "Hidden"
      }
    },
    "list": {
      "pageTitle": "Options",
      "pageSubtitle": "Manage your product option attributes, value lists, labels, and fulfillment variant options.",
      "tabOptions": "Options",
      "tabLabels": "Option Labels",
      "searchPlaceholder": "Search Option...",
      "searchAria": "Search options by name",
      "filterLabelAll": "Option Label: All",
      "filterLabelAria": "Filter by option label",
      "filterUpdatedByAll": "Updated By: All",
      "filterUpdatedByAria": "Filter by last editor",
      "filterLastUpdatedAll": "Last Updated: All",
      "filterDateClear": "Clear",
      "filterDateClearAria": "Clear the Last Updated filter",
      "filterLoading": "Loading…",
      "createAction": "Create Option",
      "working": "Saving…",
      "colLabel": "Label",
      "colName": "Option Name",
      "colValues": "Option Values",
      "colCreated": "Created",
      "colLastUpdated": "Last Updated",
      "colUpdatedBy": "Updated By",
      "colStatus": "Status",
      "colActions": "Actions",
      "noValues": "no values yet",
      "showAllValuesAria": "Show all values of {{name}}",
      "expandValuesAria": "Show {{count}} more values of {{name}}",
      "collapseValues": "Show less",
      "statusToggleAria": "Toggle status of {{name}}",
      "editAria": "Edit {{name}}",
      "statusSaved": "Status updated.",
      "statusFailed": "Could not update the status.",
      "createSaved": "Option created.",
      "updateSaved": "Option updated.",
      "saveFailed": "Could not save the option.",
      "loadError": "Could not load options.",
      "retry": "Retry",
      "empty": "No options match the current filters.",
      "rowsPerPage": "Rows per page:",
      "showingRange": "Showing {{from}}–{{to}} of {{total}} options",
      "paginationAria": "Options pagination",
      "prevPage": "Previous page",
      "nextPage": "Next page",
      "updatedByTooltip": "{{email}} — last updated {{at}}",
      "filterDateCancel": "Cancel",
      "filterDateApply": "Apply",
      "filterDatePresetToday": "Today",
      "filterDatePresetYesterday": "Yesterday",
      "filterDatePresetLast7": "Last 7 days",
      "filterDatePresetLast30": "Last 30 days"
    },
    "form": {
      "createTitle": "Create Option",
      "editTitle": "Update Option",
      "labelLabel": "Option Label",
      "labelRequired": "Please select an option label.",
      "labelsLoading": "Loading option labels…",
      "labelsEmpty": "No active option labels yet — add one on the Option Labels tab first.",
      "nameLabel": "Option Name",
      "namePlaceholder": "Enter option name",
      "nameHint": "Name used to manage this Option in the Admin system.",
      "nameRequired": "Please enter the options name.",
      "valuesTitle": "Option Values",
      "valuesSubtitle": "Add values for this option. Each value will be used to create variants and generate SKUs.",
      "addValueLabel": "Add Value",
      "addValuePlaceholder": "Enter value and press Enter",
      "valuesRequired": "Please enter at least one value.",
      "valueDuplicate": "The value \"{{code}}\" is already in the list.",
      "valueCodeInvalid": "That value has no letters or digits to build a code from.",
      "colHex": "HEX Color",
      "colCode": "Code",
      "colDisplayName": "Display Name",
      "colRemove": "Remove value",
      "codeLocked": "Code cannot be changed after the value is saved.",
      "hexAria": "HEX colour of {{code}}",
      "hexPickerAria": "Pick the colour of {{code}}",
      "removeValueAria": "Remove the value {{code}}",
      "cancel": "Cancel",
      "save": "Save",
      "labelLocked": "The option label is fixed once the option exists.",
      "hexNAria": "HEX colour {{n}} of {{code}}",
      "hexPickerNAria": "Pick colour {{n}} of {{code}}",
      "addHexAria": "Add another colour to {{code}}",
      "addHexTitle": "Add a colour (up to {{max}})",
      "removeHexAria": "Remove colour {{n}} of {{code}}",
      "hexInvalid": "\"{{value}}\" is not a valid HEX colour — use #RRGGBB.",
      "hexRequired": "A colour value needs at least one HEX colour."
    }
  },
  "location": {
    "status": {
      "active": "Active",
      "inactive": "Inactive"
    },
    "fields": {
      "addrLine1": "Address (line 1)",
      "addrLine2": "Address (line 2)",
      "addressHeading": "Warehouse address (ship-from)",
      "city": "City",
      "code": "Code (immutable)",
      "country": "Country",
      "countryIso": "Country (ISO-2)",
      "descriptionEn": "Description (EN)",
      "descriptionVi": "Description (VI)",
      "latitude": "Latitude",
      "logisticsHeading": "Logistics",
      "longitude": "Longitude",
      "name": "Name",
      "state": "State",
      "status": "Status",
      "timezone": "Timezone",
      "zip": "ZIP code"
    },
    "placeholders": {
      "addrLine1": "e.g. 7510 Garden Grove Blvd",
      "addrLine2": "Optional (Unit/Suite…)",
      "city": "Westminster",
      "country": "Type to search (e.g. Vi, Vietnam, VN)",
      "countrySelect": "Select country",
      "countrySearch": "Type to search (e.g. VN, Vietnam)",
      "descriptionEn": "e.g. Main fulfillment hub serving Southeast Asia",
      "descriptionVi": "Vietnamese description (optional)",
      "name": "Enter name",
      "timezone": "Type to search (e.g. Ho_Chi_Minh, Tokyo, UTC)",
      "timezoneSelect": "Select timezone"
    },
    "actions": {
      "cancel": "Cancel",
      "delete": "Delete",
      "create": "Create",
      "save": "Save",
      "saveChanges": "Save changes",
      "saving": "Saving…",
      "newLocation": "Create Location"
    },
    "toast": {
      "createFailed": "Could not create the location",
      "created": "Location created",
      "statusUpdated": "Status updated",
      "toggleFailed": "Toggle status failed",
      "updateFailed": "Could not update the location",
      "updated": "Location updated"
    },
    "form": {
      "description": "Add a new location to the system.",
      "editSubtitle": "Update location details and configuration.",
      "editTitle": "Update Location",
      "errors": {
        "nameRequired": "Name is required",
        "countryIso": "Country must be 2-letter ISO code (e.g. VN, US)",
        "coordsNumeric": "Coordinates must be numeric",
        "coordsRange": "Coordinates out of range",
        "submitFailed": "Submit failed",
        "fieldRequired": "{{field}} is a required field.",
        "addressIncomplete": "Warehouse address needs City, State and ZIP code.",
        "invalidTimezone": "Timezone must be a valid IANA zone (e.g. Asia/Ho_Chi_Minh) — pick from the list, don't include the offset.",
        "descriptionEnRequired": "Description needs the English text — the Vietnamese box alone cannot be saved.",
        "imageRequired": "Pick an image for this location."
      },
      "imageChange": "Change",
      "imageCurrent": "Current image",
      "imageDropzone": "Click to upload or drag and drop",
      "imageDropzoneHint": "PNG, JPG up to {{max}}",
      "imageLabel": "Image",
      "countryLockedHint": "Country can't be changed after a location is created — vendor pools, shipping rates and tax rules are keyed on it.",
      "countryNoMatch": "No matching country.",
      "imageRemove": "Remove",
      "imageSizeError": "The image must be {{max}} or smaller.",
      "imageTypeError": "Only PNG, JPG or WebP images are accepted.",
      "imageUploadAria": "Upload a location image",
      "imageUploadError": "The image could not be uploaded.",
      "imageUploading": "Uploading…",
      "moreSettings": "More settings",
      "newTitle": "Create Location"
    },
    "list": {
      "activeToggleAria": "Active toggle for {{code}}",
      "columns": {
        "nameCode": "Name / Code",
        "country": "Country",
        "timezone": "Timezone",
        "status": "Status",
        "active": "Active",
        "image": "Image",
        "name": "Name",
        "code": "Code",
        "createdDate": "Created date",
        "creator": "Creator",
        "action": "Action"
      },
      "editAria": "Edit location {{code}}",
      "empty": "No locations match the current filters.",
      "filters": {
        "search": "Search",
        "searchPlaceholder": "Search by code, name…",
        "country": "Country",
        "anyPlaceholder": "Any",
        "status": "Status",
        "allStatuses": "Status: All",
        "searchAria": "Search locations",
        "statusAria": "Filter by status"
      },
      "heading": "Location",
      "loadFailed": "Load failed",
      "loading": "Loading…",
      "nextPage": "Next page",
      "paginationAria": "Locations pagination",
      "prevPage": "Previous page",
      "retry": "Retry",
      "rowsPerPage": "Rows per page:",
      "showingRange": "Showing {{from}}–{{to}} of {{total}} locations",
      "subtitle": "Manage your production locations, country configurations, and manufacturing facilities.",
      "vendorsAria": "View vendors for {{name}}",
      "working": "Working…"
    },
    "toggle": {
      "deactivate": "Deactivate",
      "activate": "Activate",
      "deactivateTitle": "Deactivate location?",
      "activateTitle": "Activate location?",
      "deactivateDesc": "Blueprints linked to this location keep the reference but it disappears from pickers until reactivated.",
      "activateDesc": "It becomes selectable in blueprint pickers again."
    },
    "detail": {
      "toast": {
        "saved": "Saved",
        "saveFailed": "Save failed",
        "deleted": "Location deleted",
        "deleteFailed": "Delete failed"
      },
      "notFound": "Location not found.",
      "backToList": "← Back to list",
      "backToLocations": "← Back to Locations",
      "deleteTitle": "Delete location?",
      "deleteDesc": "Soft-delete {{code}} — {{name}}. Blueprints linked to this location keep the id but the location stops showing in admin lists."
    },
    "vendors": {
      "colCode": "Code",
      "colCreated": "Created date",
      "colName": "Vendor name",
      "colStatus": "Status",
      "colUpdated": "Last update",
      "colUpdatedBy": "Update by",
      "empty": "No vendor is registered in {{country}} yet.",
      "loadFailed": "The vendor list could not be loaded.",
      "paginationAria": "Vendors pagination",
      "reactivateConfirm": "Reactivate",
      "reactivateDesc": "The vendor starts receiving orders again. A permanently suspended vendor cannot be reactivated here.",
      "reactivateTitle": "Reactivate {{name}}?",
      "reasonHint": "At least {{min}} characters — it is stored in the suspension history.",
      "reasonLabel": "Reason",
      "reasonPlaceholderReactivate": "Optional note for the audit trail",
      "reasonPlaceholderSuspend": "Why is this vendor being suspended?",
      "reasonTooShort": "The reason needs at least {{min}} characters.",
      "showingRange": "Showing {{from}}–{{to}} of {{total}} vendors",
      "status": {
        "active": "Active",
        "inactive": "Inactive",
        "pending_activation": "Pending activation",
        "suspended": "Suspended"
      },
      "statusLocked": "{{name}} is {{status}} — activation happens on the vendor page, not here",
      "statusSwitchAria": "{{name}} is {{status}} — press to change it",
      "subtitle": "Vendors registered in {{country}}, the country this production location covers.",
      "suspendConfirm": "Suspend",
      "suspendDesc": "The vendor stops receiving new orders. The hold period escalates with each suspension.",
      "suspendTitle": "Suspend {{name}}?",
      "title": "Vendors — {{name}}",
      "toast": {
        "suspended": "{{name}} suspended",
        "reactivated": "{{name}} reactivated",
        "suspendFailed": "Could not suspend the vendor",
        "reactivateFailed": "Could not reactivate the vendor"
      },
      "refreshing": "Refreshing the list…"
    }
  },
  "print_area": {
    "title": "Print Areas",
    "subtitlePre": "Catalog of print areas used for the template Validation Area.",
    "subtitlePost": "is the immutable machine identity after creation; only Label and Order are editable.",
    "actions": {
      "create": "New print area"
    },
    "columns": {
      "code": "Code",
      "label": "Label",
      "order": "Order",
      "status": "Status",
      "actions": "Actions"
    },
    "empty": "No print areas yet.",
    "status": {
      "active": "Active",
      "archived": "Archived"
    },
    "rowActions": {
      "edit": "Edit",
      "archive": "Archive",
      "unarchive": "Unarchive",
      "delete": "Delete"
    },
    "form": {
      "createTitle": "New print area",
      "editTitle": "Edit print area",
      "codeLabel": "Code",
      "codePlaceholder": "e.g. chest_pocket",
      "codeImmutableHint": "Code is immutable after creation (machine identity).",
      "labelLabel": "Label",
      "orderLabel": "Sort order",
      "orderPlaceholder": "leave empty → append to end",
      "archivedLabel": "Archived (hidden from new Validation Area dropdown)",
      "cancel": "Cancel",
      "save": "Save",
      "saving": "Saving…"
    },
    "delete": {
      "title": "Delete print area?",
      "description": "Only unreferenced print areas can be deleted. If it is in use, archive instead of deleting to keep the reference.",
      "confirm": "Delete",
      "cancel": "Cancel"
    },
    "validation": {
      "codePattern": "Code must start with a letter or digit, then letters, digits, underscores or hyphens only.",
      "codeRequired": "Code is required.",
      "labelRequired": "Label is required.",
      "sortOrderInteger": "Order must be a whole number."
    },
    "toast": {
      "loadFail": "Failed to load print areas",
      "saveFail": "Save failed",
      "created": "Print area created",
      "updated": "Print area updated",
      "statusFail": "Failed to update status",
      "archived": "Print area archived",
      "unarchived": "Unarchived",
      "deleteFail": "Delete failed",
      "deleted": "Print area deleted"
    }
  },
  "label": {
    "searchPlaceholder": "Search labels…",
    "actions": {
      "add": "Add Label"
    },
    "columns": {
      "name": "Name",
      "code": "Code",
      "status": "Status",
      "actions": "Actions",
      "lastUpdate": "Last update"
    },
    "loading": "Loading labels…",
    "emptyNone": "No labels yet. Add one to start grouping options.",
    "emptySearch": "No labels match the search.",
    "status": {
      "Active": "Active",
      "Inactive": "Inactive"
    },
    "rowActions": {
      "edit": "Edit"
    },
    "dialog": {
      "editTitle": "Edit label",
      "createTitle": "Create new label"
    },
    "form": {
      "nameLabel": "Name",
      "namePlaceholder": "Enter label name",
      "codeLabel": "Code",
      "codePlaceholder": "Auto-filled from the name",
      "codeHint": "Auto-generated from the name. Not editable.",
      "cancel": "Cancel",
      "saving": "Saving…",
      "saveChanges": "Save changes",
      "creating": "Creating…",
      "createLabel": "Create label",
      "nameHint": "Name shown when picking an option label."
    },
    "validation": {
      "nameRequired": "Name is required",
      "codeFormat": "Code must be lowercase_snake_case",
      "codeFormatDesc": "Letters, digits, underscores only; must start with a letter.",
      "codeRequired": "Code is required"
    },
    "toast": {
      "updated": "Label updated",
      "created": "Label created",
      "updateFailed": "Update failed",
      "createFailed": "Create failed",
      "deleted": "Label deleted",
      "deleteFailed": "Delete failed",
      "unknownError": "Unknown error",
      "statusSaved": "Label status updated",
      "statusFailed": "Could not update label status"
    },
    "statusToggleAria": "Toggle status for {{name}}",
    "editAria": "Edit label {{name}}",
    "loadError": "Could not load labels.",
    "retry": "Retry",
    "rowsPerPage": "Rows per page",
    "showingRange": "Showing {{from}}–{{to}} of {{total}} labels",
    "prevPage": "Previous page",
    "nextPage": "Next page",
    "paginationAria": "Label list pagination"
  },
  "material": {
    "title": "Materials",
    "subtitle": "Catalog of materials used by template layers (wood, acrylic, fabric…). Layers reference the materials defined here.",
    "actions": {
      "create": "New material"
    },
    "empty": "No materials yet.",
    "columns": {
      "code": "Code",
      "name": "Name",
      "group": "Group",
      "thickness": "Thickness (mm)",
      "engravable": "Engravable",
      "status": "Status",
      "actions": "Actions"
    },
    "status": {
      "active": "Active",
      "inactive": "Inactive"
    },
    "rowActions": {
      "edit": "Edit",
      "delete": "Delete"
    },
    "form": {
      "createTitle": "New material",
      "editTitle": "Edit material",
      "codeLabel": "Code",
      "codePlaceholder": "e.g. clear_acrylic",
      "nameEnLabel": "Name (EN)",
      "nameViLabel": "Name (VI)",
      "groupLabel": "Group",
      "groupPlaceholder": "acrylic / wood / fabric",
      "thicknessLabel": "Thickness (mm)",
      "thicknessPlaceholder": "leave empty if not applicable",
      "engravableLabel": "Engrave compatible",
      "activeLabel": "Active",
      "cancel": "Cancel",
      "save": "Save",
      "saving": "Saving…"
    },
    "delete": {
      "title": "Delete material?",
      "description": "The material will be removed from the catalog (soft-delete). Layers in use keep their existing reference.",
      "confirm": "Delete",
      "cancel": "Cancel"
    },
    "validation": {
      "required": "Code and Name (EN) are required"
    },
    "toast": {
      "loadFail": "Failed to load materials",
      "saveFail": "Save failed",
      "created": "Material created",
      "updated": "Material updated",
      "deleteFail": "Delete failed",
      "deleted": "Material deleted"
    }
  },
  "check_type": {
    "title": "Check Types",
    "subtitle": "Artwork Doctor check registry. Toggle on/off (checklist) or carry parameters (e.g. minimum stroke). Admins add new checks as new products require them.",
    "actions": {
      "create": "New check type"
    },
    "empty": "No check types yet.",
    "columns": {
      "code": "Code",
      "label": "Label",
      "scope": "Scope",
      "params": "Params",
      "severity": "Severity",
      "status": "Status",
      "actions": "Actions"
    },
    "status": {
      "active": "Active",
      "inactive": "Inactive"
    },
    "rowActions": {
      "edit": "Edit",
      "delete": "Delete"
    },
    "form": {
      "createTitle": "New check type",
      "editTitle": "Edit check type",
      "codeLabel": "Code",
      "codePlaceholder": "e.g. MIN_STROKE_SIZE",
      "labelEnLabel": "Label (EN)",
      "labelViLabel": "Label (VI)",
      "scopeLabel": "Scope",
      "severityLabel": "Default severity",
      "severityError": "error (block)",
      "severityWarning": "warning (soft)",
      "hasParamsLabel": "Has parameters (param mode) — uncheck = checklist on/off",
      "paramsTitle": "Parameters (key → type)",
      "addParam": "Add parameter",
      "paramKeyPlaceholder": "e.g. minCm",
      "activeLabel": "Active",
      "cancel": "Cancel",
      "save": "Save",
      "saving": "Saving…"
    },
    "delete": {
      "title": "Delete check type?",
      "description": "The check type will be removed from the registry (soft-delete).",
      "confirm": "Delete",
      "cancel": "Cancel"
    },
    "validation": {
      "required": "Code and Label (EN) are required",
      "paramsRequired": "Param mode needs at least 1 parameter"
    },
    "toast": {
      "loadFail": "Failed to load check types",
      "saveFail": "Save failed",
      "created": "Check type created",
      "updated": "Check type updated",
      "deleteFail": "Delete failed",
      "deleted": "Check type deleted"
    }
  },
  "opacity": {
    "preflight": {
      "invalidMime": "Only PNG files (image/png) are accepted. This file has MIME: {{mime}}.",
      "unknownMime": "unknown",
      "tooLarge": "File size exceeds {{mb}} MB."
    },
    "decode": {
      "failed": "Cannot decode PNG: {{detail}}",
      "badDimensions": "PNG has invalid dimensions.",
      "noCanvas": "Browser does not support 2D canvas.",
      "noAlpha": "PNG has no alpha channel (all pixels opaque). The template needs a PNG with varying transparency levels."
    },
    "worker": {
      "runtimeError": "Worker failed to initialize."
    }
  },
  "blueprintWizard": {
    "title": "Logistics & fees",
    "subtitle": "Rush service, customs and handling knobs for this blueprint.",
    "hsCodeLabel": "HS code",
    "hsCodePlaceholder": "e.g. 6109.10",
    "handleFeeLabel": "Handling fee",
    "rushSectionLabel": "Rush service fees",
    "rushServiceLabel": "Service",
    "rushFeeLabel": "Rush fee",
    "rushFeePlaceholder": "0.00",
    "rushDeadlineLabel": "Rush deadline (hours)",
    "addRush": "Add rush tier",
    "removeRush": "Remove",
    "samplePolicyLabel": "Sample policy",
    "samplePolicies": {
      "none": "No samples",
      "chargeable": "Chargeable",
      "free_first": "First sample free"
    },
    "accessorySectionLabel": "Accessory",
    "isAccessoryLabel": "This blueprint is an accessory add-on",
    "chargeAdditionalFromQtyLabel": "Charge additional shipping from quantity",
    "services": {
      "ECONOMY": "Economy",
      "STANDARD": "Standard",
      "PRIORITY": "Priority",
      "NEXT_DAY": "Overnight"
    }
  },
  "tiktokLabelEntitlement": {
    "_vgBinding": "vg-binding: P14.1.D-36 — Merchant Detail tiktokLabelEntitled toggle (label-provided shipping bypass grant) across en/vi/fr",
    "title": "Provided-label shipping bypass",
    "ariaLabel": "Toggle provided-label shipping bypass entitlement",
    "readOnly": "You do not have permission to change this setting.",
    "states": {
      "on": "Entitled",
      "off": "Not entitled"
    },
    "helper": {
      "on": "Orders using an uploaded shipping label (TikTok, Etsy, self-bought) skip shipping and seasonal shipping fees and pay a single handling fee per order.",
      "off": "Label orders are charged normal shipping. Enable to let this merchant use uploaded labels (TikTok, Etsy, self-bought) and pay only the handling fee."
    },
    "toasts": {
      "saved": "Label entitlement updated.",
      "error": "Failed to update label entitlement."
    }
  },
  "tierFeeTable": {
    "colArea": "Area",
    "colAdditionalFee": "Price",
    "colRequired": "Required",
    "requiredToggleAria": "Toggle required for {{name}}",
    "feeInputAria": "{{tier}} additional fee for {{name}}",
    "expand": "Expand {{name}}",
    "collapse": "Collapse {{name}}",
    "colDisplay": "Display",
    "displayToggleAria": "Show {{name}} on the storefront",
    "selectAllAria": "Select all rows",
    "selectRowAria": "Select {{name}}",
    "selectedCount": "{{count}} area selected",
    "basePriceAria": "Price for {{name}}",
    "tierRequiredAria": "Toggle required for {{name}} on tier {{tier}}",
    "tierDisplayAria": "Show {{name}} on the storefront for tier {{tier}}",
    "areaFlagScopeHint": "Required / Display apply to every location",
    "tierFlagScopeHint": "Per-tier switches apply to this location only"
  },
  "blueprintLogistics": {
    "columnSku": "SKU",
    "columnStatus": "Status",
    "columnShippingFee": "Shipping Fee ($)",
    "columnSeasonalFee": "Seasonal Fee ($)",
    "columnAdditionalFee": "Additional Fee ($)",
    "columnReciprocalTariff": "Reciprocal Tariff ($)",
    "defaultLabel": "Default",
    "empty": "No SKUs yet — pick options in the Options block first.",
    "selectAllAria": "Select all SKUs",
    "selectRowAria": "Select {{sku}}",
    "statusToggleAria": "Toggle {{sku}} active",
    "servicesLoading": "Loading shipping services…",
    "noServices": "No shipping services in the catalogue yet — add them under Shipping → Methods."
  },
  "accessoryFeeTable": {
    "colAccessory": "Accessories",
    "colPrice": "Price",
    "colShippingFee": "Shipping fee",
    "colMinQty": "Min qty",
    "colMaxQty": "Max qty",
    "colRequired": "Required",
    "removeAria": "Remove {{name}}",
    "collapse": "Collapse {{name}}",
    "expand": "Expand {{name}}",
    "priceAria": "Price for {{name}}, {{tier}} tier",
    "shippingAria": "Shipping fee for {{name}}, {{tier}} tier",
    "minQtyAria": "Minimum quantity for {{name}}",
    "maxQtyAria": "Maximum quantity for {{name}}",
    "requiredAria": "Require {{name}} on every order",
    "tierMinQtyAria": "Minimum quantity for {{name}}, {{tier}} tier",
    "tierMaxQtyAria": "Maximum quantity for {{name}}, {{tier}} tier",
    "tierRequiredAria": "Require {{name}} for the {{tier}} tier"
  }
}
